
"use strict";

membershipApp.controller('MembershipController', ['$scope', '$http', '$timeout', '$translate', '$filter', function ($scope, $http, $timeout, $translate, $filter) {
	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		$('.logout').on('click', function () {
			$('.logout').toggleClass('active');
		});

		$('body').addClass('mobile')
	}

	var $translateThis = $filter('translate');
	$scope.order = { orderZone: $scope.cardZone, orderCard: $scope.cardType };
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth() + 1;
	var yyyy = today.getFullYear();
	var lastYear = today.getFullYear() - 1;
	var nextYear = today.getFullYear() +	 1;
	var last100Year = today.getFullYear() - 100;
	$scope.newRegistration = false;
	$scope.dashLogin = true;
	$scope.visitsItemsSize = 10;
	$scope.productsItemsSize = 10;
	$scope.choosenMembership = false;
	const lastLang = getCookie('setLang');

	var startYear = new Date().getFullYear().toString().substr(-2);
    var currentYear = new Number(startYear);
    currentYear += 20;
    $scope.years = [];

    while (startYear <= currentYear) {
        $scope.years.push(startYear++);
    }

	$(window).on('resize load', function(){
		if ( $(window).width() < 768 ){
			$scope.visitsItemsSize = 3;
			$scope.productsItemsSize = 3;			
		}else{
			$scope.visitsItemsSize = 10;
			$scope.productsItemsSize = 10;
		}
		$scope.$apply();
	})

	if ( isMobile ){
		$scope.mobileApp = isMobile;
	}

	if ( lang ){
		$translate.use(lang);
	}

	$scope.text = 'me@example.com';
	$scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	if (dd < 10) {
		dd = '0' + dd
	}

	if (mm < 10) {
		mm = '0' + mm
	}

	today = mm + '/' + dd + '/' + yyyy;
	todayOneYearAgo = mm + '/' + dd + '/' + lastYear;
	todayPlusOneYear = mm + '/' + dd + '/' + nextYear;
	todayOneHundredYearAgo = mm + '/' + dd + '/' + last100Year;

	if( $scope.mobileApp ){
		$scope.filterStartDate = new Date(todayOneYearAgo);
		$scope.filterEndDate = new Date(today);
	}

	// $scope.showLogin = function () {
	// 	$scope.dashLogin = true;
	// }
	// $scope.showLogin();

	// $scope.hideLogin = function () {
	// 	$scope.dashLogin = false;
	// }

	if (newRegistration) {
		$scope.newRegistration = true;
	}

	var paysafeinit = false;
	var Model = window.Model;

	if (clientModel) {
		$scope.Model = clientModel;
		$scope.Client = $scope.Model.Client;

		if ($scope.Model.Register) {
			$scope.FormRegister = $scope.Model.Register;
		}
	}

	if (gymdivision) {
		$scope.Division = gymdivision.GymName;
		$scope.DivisionID = gymdivision.GymID;
		var $translateThis = $filter('translate');
		var title = $translateThis('title');
		document.title = $scope.Division + ' ' + title;
	}


	$scope.dateFeaturedFormat = 'dd/MM/yyyy';
	$scope.dateFeaturedFormatDatepicker = 'dd/mm/yy';
	if (gym) {
		$scope.gym = gym;
		$scope.gymName = $scope.gym.GymName;
		$scope.AdditionInfo;
		$scope.currentLang = $translate.proposedLanguage() || $translate.use();

		if ($scope.currentLang == 'bg') {
			$scope.AdditionInfo = $scope.gym[0].AdditionalInformation;
			$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['bg']);
		}else if($scope.currentLang == 'es' || $scope.currentLang == 'esc'){
			$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
			$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['es']);
		}else{
			$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
			$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['en']);
		}


		if ($scope.AdditionInfo) {
			var prtext = $scope.AdditionInfo.replace(/\n/g, '<br />')
			$(window).on('load', function () {
				$('.section-addtext').html(prtext);
			});
		}

		if ( gym[0].Culture == 'en-US' ) {
			$scope.dateFeaturedFormat = 'MM/dd/yyyy';
			$scope.dateFeaturedFormatDatepicker = 'mm/dd/yy';
		}
		
		if (!lastLang && gym[0].Culture) {
			if (gym[0].Culture.includes('-ES') ) {
				if (gym[0].Culture == 'ca-ES' || gym[0].Culture == 'ca-ES-valencia') {
					$translate.use('esc');
					$scope.currentLang = 'esc';	
				}else{
					$translate.use('es');
					$scope.currentLang = 'es';
				}
			}else if (gym[0].Culture == 'bg-BG'){
				$translate.use('bg');
				$scope.currentLang = 'bg';
			}else{
				$translate.use('en');
				$scope.currentLang = 'en';	
			}
		}
	}

	if (learnedFrom) {
		$scope.learnedFrom = learnedFrom
	}

	$scope.getClientServices = function () {
		var dataObject = {
			Namespace: namespace,
			Email: $scope.Client.Email,
			datestart: today,
			dateend: todayPlusOneYear
		}
		$http({
			method: 'POST',
			url:'/ScheduleV2/GetClientSchedule',
			data: dataObject
		}).success(function (data) {
			if ( data.length == 0 ) {
				$scope.noEvents = true;
			}
			else{
				$scope.noEvents = false;	
			}
		}).error(function () {

		});
	}

	// Clients Portal - Language Switch
	$scope.$on('$translateChangeSuccess', function (event, current, previous) {
		$scope.currentLang = $translate.proposedLanguage() || $translate.use();
	});

	$scope.changeLanguage = function (lang) {
		$translate.use(lang);
		$scope.currentLang = lang;

		setCookie('setLang', lang);
		// if (lang == 'en' || lang == 'bg') {
		// }
	}

	// Cients Portal Filter 
	var from = $("#from");
	var to = $("#to");

	$scope.getItemsFromThePast = function (item) {
		var today = new Date();
		return item.date < today;
	}

	$scope.currentLang = $translate.proposedLanguage() || $translate.use();

	from.datepicker({
		changeMonth: true,
		numberOfMonths: 1,
		dateFormat: $scope.dateFeaturedFormatDatepicker,
		onSelect: function (dateText, inst) {
			var origin_date = $(this).val();

			if ($scope.gym[0].Culture != 'en-US') {
				var res = origin_date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			$scope.filterStartDate = date;
			to.datepicker("option", "minDate", origin_date);
		}
	});

	to.datepicker({
		changeMonth: true,
		numberOfMonths: 1,
		dateFormat: $scope.dateFeaturedFormatDatepicker,
		// dateFormat: 'mm.dd.yy',
		onSelect: function (dateText, inst) {
			var origin_date = $(this).val();

			if ($scope.gym[0].Culture != 'en-US') {
				var res = origin_date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			$scope.filterEndDate = date;
			from.datepicker("option", "maxDate", origin_date);
		}
	});

	// Clients Portal - Language Switch on Additional Text
	$('.lang-nav a').on('click', function (e) {
		var lang = $(this).data('lang');

		if (lang == 'bg') {
			$scope.AdditionInfo = $scope.gym[0].AdditionalInformation;
			$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['bg']);
		}else if(lang == 'es' || lang == 'esc'){
			$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
			$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['es']);
		}else{
			$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
			$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['en']);
		}

		if ($scope.gym[0].Culture == 'en-US') {
			$('#from, #to, #schedule_to, #schedule_from').datepicker( "option", "dateFormat", "mm/dd/yy" );
		} else {
			$('#from, #to, #schedule_to, #schedule_from').datepicker( "option", "dateFormat", "dd/mm/yy" );
		}

		if ($scope.AdditionInfo) {
			var prtext = $scope.AdditionInfo.replace(/\n/g, '<br />')
			$('.section-addtext').html(prtext);
		}
	})

	// Tabs
	$('#mytabs .nav-tabs a').click(function (e) {
		e.preventDefault()
		$(this).tab('show')
	});

	// Rate function
	$scope.rate = function (rate, comment) {
		var dataObject = {
			Rating: rate,
			ClientID: $scope.Client.ClientID,
			Comment: comment,
			Namespace: namespace,
			GymId: $scope.gymId,
			VisitID: $scope.visitId,
		}
		$http({
			method: 'POST',
			url: '/rating/RateVisit',
			data: dataObject
		}).success(function (data) {
			$('.popup-wrapper').removeClass('show');
		}).error(function () {
		});
	}

	$scope.dateFilter = function (from, to) {
		var fromT = new Date(from);
		var toT = new Date(to);
		toT.setHours(23, 59, 0, 0);

		var dataObject = {
			ClientID: $scope.Client.ClientID,
			CardID: $scope.Client.CardID,
			Email: $scope.Client.Email,
			DateStart: fromT,
			DateEnd: toT,
			Namespace: namespace,
			GymId: gymid,
		}

		$scope.paging = [];
		$scope.products_paging = [];

		$http({
			method: 'POST',
			url: '/account/GetReport',
			data: dataObject
		}).success(function (data) {
			$scope.visits = data.Visits;
			$scope.memberships = data.PastServices;
			$scope.products = data.Products;
			$scope.Services = data.Services;
			$scope.Deposit = data.Deposit;

			if ($scope.Services.length > 0) {
				$scope.activeServices = false;
			} else {
				$scope.activeServices = true;
			}
		}).error(function () {
		});
	}

	$(window).on('load', function () {
		if ($('.dashboard').length) {

			$(".membership-wrapper").addClass('show-forgetme');

			setTimeout(function () {
				$scope.dateFilter(todayOneYearAgo, today);
			}, 1500);
		}
		// if ( $scope.Client ) {
		// 	$scope.getClientServices();
		// }


		// console.log($scope.currentLang);
		// let phoneLang = $scope.currentLang == 'en' ? 'gb' : $scope.currentLang;
		// console.log(phoneLang);

		// $('#RegPhone').intlTelInput({
	 //        autoHideDialCode: false,
	 //        preferredCountries: [phoneLang],
	 //        separateDialCode: true
	 //    });
	})

	// Popup
	$('.popup-wrapper .close').on('click', function (e) {
		e.preventDefault();
		$('.popup-wrapper').removeClass('show');
	})

	$scope.popupOpen = function (visitId, gymId) {
		$('.popup-wrapper[data-id="rateVisit"]').addClass('show');
		$scope.visitId = visitId;
		$scope.gymId = gymId;
	}

	$('.calendar-filter .field i').on('click', function (e) {
		$(this).parent().find('input').datepicker('show');
	});

	// Get Settings

	if (namespace) {
		$scope.getSettings = function () {
			var dataObject = {
			    Namespace: namespace,
			    GymID: $scope.DivisionID
			}
			$http({
				method: 'POST',
				url: '/Membership/GetSettings',
				data: dataObject
			}).success(function (data) {
				$scope.membershipSettings = data;
				$scope.countriesSettings = data.Countries;

				if ($scope.membershipSettings.Culture == 'bg-BG') {
					$scope.currency = 'лв.';
				}else if($scope.membershipSettings.Culture.includes('-ES')){
					$scope.currency = 'eur';
				}else {
					$scope.currency = '$';
				}

				if (customCurrency) {
					$scope.currency = customCurrency;
				}
			}).error(function () {
				// console.log('error');
			});
		}

		$scope.getSettings();
	}

	// Index forms

	// Register

	$scope.accRegister = function () {
		$scope.loading = true;
		$scope.currentLang = $translate.proposedLanguage() || $translate.use();

		var gymid = $('#accGymID').val();
		var namespace = $('#Namespace').val();
		var regbirthdate = $('#RegBirthdate').val();
		var res = regbirthdate.split("/");
		var date = res[1] + '/' + res[0] + '/' + res[2];
		var intlNumber = $(".flag-container .selected-dial-code").html() + $('#RegPhone').val();

		if ($scope.gym[0].Culture == 'en-US') {
			date = regbirthdate;
		} else {
			date = date;
		}

		var dataObject = {
			RegEmail: $('#RegEmail').val(),
			RegPassword: $('#RegPassword').val(),
			RegConfirmPassword: $('#RegConfirmPassword').val(),
			RegFirstName: $('#RegFirstName').val(),
			RegLastName: $('#RegLastName').val(),
			Namespace: namespace,
			GymID: gymid,
			Male: $scope.regSexRadio,
			Telephone: intlNumber,
			DivisionID: $('#RegGym').val(),
			Birthdate: date,
			LearnedFrom: $('#RegLearnedFrom').val(),
			WorkAddress: $('#RegWorkAddress').val(),
			RecommendBy: $('#RegRecommendBy').val()
		}

		$http({
			method: 'POST',
			url: '/account/register/',
			data: dataObject
		}).success(function (data) {
			var data = data;
			var currentHref = window.location;
			var href = currentHref.origin + '/Account/ConfirmYourEmail?nameSpace=' + namespace + '&gymId=' + gymid;
			if ( isMobile == true ) {
				href += '&isMobile=true';
			}	

			if (data == 'Success') {
				window.location.replace(href);
			} else {
				var n = data.search("com is already taken");

				if (n > 0) {
					var translated = $translateThis('User Taken');
					$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
				} else {
					var res = data.split(".");

					if (res.length > 2) {
						$('.validation-errors').html('<div class="section-valid"></div>');
						for (var i = 0; i < res.length - 1; i++) {
							var msg = res[i] + '.';
							var translated = $translateThis(msg);
							$('.validation-errors .section-valid').append('<p>' + translated + '</p>');
						}
					} else {
						var translated = $translateThis(data);
						$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
					}
				}
			}
			$scope.loading = false;

		}).error(function () {
			// console.log('error');
		});
	};


	// Login

	$scope.accLogin = function () {

		$scope.loading = true;

		var gymid = $('#accGymID').val();
		var namespace = $('#Namespace').val();

		var email = $('#Email').val();
		email = email.replace(/ /g,'');
		var password = $('#Password').val();
		var rememberme = $('#rememberMe').val();



		var dataObject = {
			Email: email,
			Password: password,
			RememberMe: rememberme,
			Namespace: namespace,
			GymID: gymid
		}

		$http({
			method: 'POST',
			url: '/account/login/',
			data: dataObject
		}).success(function (data) {
			var data = data;
			var currentHref = window.location;
			var href = currentHref.origin + '/Account/Dashboard?nameSpace=' + namespace + '&gymId=' + gymid;
			if ( isMobile == true ) {
				href += '&isMobile=true';
			}

			if (data == 'Success') {
				window.location.replace(href);
			} else {
				var translated = $translateThis(data);
				$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
			}
			$scope.loading = false;

		}).error(function () {
			// console.log('error');
		});
	};


	// ForgotPassword
	$scope.accForgotPassword = function () {
		$scope.loading = true;
		var gymid = $('#accGymID').val();
		var namespace = $('#accNamespace').val();
		var email = $('#Email').val();

		var dataObject = {
			Email: email,
			Namespace: namespace,
			GymID: gymid
		}

		$http({
			method: 'POST',
			url: '/account/forgotpassword/',
			data: dataObject
		}).success(function (data) {
			var data = data;

			if (data == 'Success') {
				var translated = $translateThis('SuccessPass');
				$('.validation-errors').html('<div class="section-valid success"><p>' + translated + '</p></div>');
			} else {
				var translated = $translateThis(data);
				$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
			}

			$scope.loading = false;
		}).error(function () {
			// console.log('error');
		});
	}

	if ($('.section-authorize').is('.resetPassword')) {
		$scope.matchingPassword = false;
		$('#Password, #ConfirmPassword').on('keyup', function () {
			if ($('#Password').val() == $('#ConfirmPassword').val()) {
				$('.validation-errors').html('');
				$scope.matchingPassword = true;
			} else {
				var translated = $translateThis('notMaching');
				$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
				$scope.matchingPassword = false;
			}
		});
	}


	if (code) {
		$scope.code = code;
	}

	$scope.resetSuccess = false;
	$scope.resetPasswordRelocate = function(){
		var currentHref = window.location;
		var href = currentHref.origin + '/Account/index?nameSpace=' + namespace + '&gymId=' + $scope.DivisionID;
		if ( isMobile == true ) {
			href += '&isMobile=true';
		}

		window.location.replace(href);
	}

	// ResetPassword
	$scope.resetPassword = function () {
		if ($scope.matchingPassword == true) {
			$scope.loading = true;

			var namespace = $('#accNamespace').val();
			var email = $('#Email').val();
			var password = $('#Password').val();
			var confirmPassword = $('#ConfirmPassword').val();

			var dataObject = {
				Email: email,
				Namespace: namespace,
				ConfirmPassword: confirmPassword,
				Password: password,
				Code: $scope.code
			}

			$http({
				method: 'POST',
				url: '/account/resetpassword/',
				data: dataObject
			}).success(function (data) {
				var data = data;

				if (data == 'Success') {
					$scope.resetSuccess = true;
					// window.location.replace(href);
				} else {
					var translated = $translateThis(data);
					$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
				}
				$scope.loading = false;
			}).error(function () {
				// console.log('error');
			});
		}
	}

	$scope.changePassword = function(){
		if ($scope.matchingPassword == true) {
			$scope.loading = true;

			var dataObject = {
				GymID: $('#accGymID').val(),
				Namespace: $('#accNamespace').val(),
				OldPassword: $('#OldPassword').val(),
				NewPassword: $('#Password').val()
			}

			$http({
				method: 'POST',
				url: '/account/changepassword/',
				data: dataObject
			}).success(function (data) {
				var data = data;
				var translated = $translateThis(data);
				$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
				
				if (data == 'Success') {
					$('.validation-errors .section-valid').addClass('success');
				}
				$scope.loading = false;
			}).error(function () {
				// console.log('error');
			});
		}
	}

	// Get Gyms
	$scope.getGyms = function () {
		var dataObject = {
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Membership/GetGyms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipGyms = data;

		}).error(function () {
			// console.log('error');
		});
	}

	$scope.getGyms();

	if (result) {
		$scope.cancelResult = result;
	}


	function setCookie(key, value) {
		var val = value;
		var expires = new Date();
		expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
		document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
		if (val != "true") {
			$('body').addClass('pound-currency');
		} else {
			$('body').removeClass('pound-currency');
		}
	}

	function getCookie(key) {
		var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
		return keyValue ? keyValue[2] : null;
	}

	$scope.redirectLogin = function () {
		var href = window.location;
		var currentHref = href.origin + '/Account?nameSpace=' + namespace + '&gymId=' + $scope.DivisionID;
		if ( isMobile == true ) {
			currentHref += '&isMobile=true';
		}
		var date = $('.step .membersip-card.checked .more-info .info-action input').val();
		setCookie('setUrl', href);
		setCookie('setDate', date);
		window.location.replace(currentHref);
	}
	// PrintClientInfoReport(int ClientID, DateTime DateStart, DateTime DateEnd, int GymID, string AppKey)

	// Get getPrint
	$scope.getPrint = function () {
		var dataObject = {
			ClientID: $scope.Client.ClientID,
			DateStart: todayOneHundredYearAgo,
			DateEnd: today,
			GymID: gymid,
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Account/PrintClientInfoReport',
			data: dataObject
		}).success(function (data) {
			if ( data ){
				var membershipPrint = data;
				window.location.replace(membershipPrint);
			}
		}).error(function () {
			// console.log('error');
		});
	}

	// Get getPrint
	$scope.forgetAboutMe = function () {

		var href = window.location;
		var currentHref = href.origin + '/Account?nameSpace=' + namespace + '&gymId=' + $scope.DivisionID;
		if ( isMobile == true ) {
			currentHref += '&isMobile=true';
		}

		var forgetAboutMe1 = 'Forgotten';
		var forgetAboutMe2 = 'Customer';

		if ($scope.currentLang = 'bg') {
			forgetAboutMe1 = 'Забравен';
			forgetAboutMe2 = 'Клиент';
		}

		var dataObject = {
			ForgetMe1: forgetAboutMe1,
			ForgetMe2: forgetAboutMe2,
			GymID: gymid,
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Account/ForgetMe',
			data: dataObject
		}).success(function (data) {

			$('.popup-wrapper').addClass('responded');

			if (data == 'true') {
				$scope.forgotten = true;

				setTimeout(function () {
					window.location.replace(currentHref);
				}, 1500);
			} else {
				$scope.forgotten = false;
				$('.popup-wrapper').removeClass('responded');
			}

		}).error(function () {
			// console.log('error');
		});
	}


	if ( gymServices ){
		$scope.gymServices = gymServices;

		if ( $scope.gymServices.length > 0 ) {
			$scope.gymServices = $.grep($scope.gymServices, function(e){ 
			     return e.Name != 'Deposit'; 
			});
		}

		if ( $scope.gymServices.length == 1 ) {
			$scope.mySubscription = $scope.gymServices[0]
			if ( $scope.mySubscription.Code ) {
				JsBarcode("#barcode", $scope.mySubscription.Code, {
					background: "transparent",
					width: 1
				});
			}
		}

		$scope.changeServiceModel = function(){
			var serviceItem = $scope.serviceModel;

			var result = $.grep($scope.gymServices, function (e) { return e.ServiceID == serviceItem; });

			if ( result.length > 0 ) {
				$scope.mySubscription = result[0];
				if ( $scope.mySubscription.Code ) {
					JsBarcode("#barcode", $scope.mySubscription.Code, {
						background: "transparent",
						width: 1
					});
				}else{
					JsBarcode("#barcode", 'Sorry, no code', {
						background: "transparent",
						width: 1
					});
				}
			}
		}
	}

	$scope.showPopup = function (sel, id) {
		var selected = sel;
		var id = id;
		$('.popup-wrapper[data-id="' + sel + '"]').addClass('show');
		if (id) {
			$('.popup-wrapper[data-id="' + sel + '"] .btn.agree').attr('data-id', id);
		}
	}

	$scope.closePopup = function (sel) {
		$('.popup-wrapper[data-id="' + sel + '"]').removeClass('show').find('.btn.agree').attr('data-id', '');
	}

	$(window).on('load', function () {
		var lastUrl = getCookie('setUrl');

		if ($('.dashboard').length && lastUrl != null && lastUrl != '') {
			var relocated = false;

			if (!relocated) {
				relocated = true;
				setCookie('setUrl', '');
				window.location.replace(lastUrl);
			}
		}

	})

	

	$scope.$watch('paymentway', function (v) {
		var paymentWayValue = v;

		if (paymentWayValue == '9') {

			$('.onepage-wrapper .actions .stripe-button').addClass('show');
			// Create a Stripe client.
			var stripe = Stripe($scope.membershipSettings.StripePublishKey);
			// Create an instance of Elements.
			var elements = stripe.elements();
			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
			  base: {
				color: '#32325d',
				lineHeight: '18px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
				  color: '#aab7c4'
				}
			  },
			  invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			  }
			};


			// Create an instance of the card Element.
			var card = elements.create('card', {style: style});

			// Add an instance of the card Element into the `card-element` <div>.
			card.mount('#card-element');

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function(event) {
				var displayError = document.getElementById('card-errors');
			  	if (event.error) {
					displayError.textContent = event.error.message;
			  	} else {
					displayError.textContent = '';
			  	}
			});

			// Handle form submission.
			var form = document.getElementById('payment-form');

			$('.stripe-button').on('click', function(e){
			    e.preventDefault();
			    if ($scope.orderLoading == false || $scope.orderLoading == undefined) {
			        $scope.orderLoading = true;
			        stripe.createToken(card).then(function (result) {
			            if (result.error) {
			                // Inform the user if there was an error.
			                var errorElement = document.getElementById('card-errors');
			                errorElement.textContent = result.error.message;
			                $scope.orderLoading = false;
			            } else {
			                // Send the token to your server.
			                $scope.token = result.token.id
			                $scope.placeOrder();
			                $scope.orderLoading = false;
			            }
			        });
			    }
				
			})
		}else{
			$('.onepage-wrapper .actions .stripe-button').removeClass('show');
		}

		if (paymentWayValue == 66) {
			$(".onepage-wrapper .actions .commbank-buttonhp").addClass('show');
			var hostedPayments = SimplifyCommerce.hostedPayments(
		        function(response) {
		            var cardToken = response.cardToken;
		            console.log(cardToken);
		            // TODO: Pass token to the server & use Simplify's API to make a payment

		            $scope.token = cardToken;
		            $scope.placeOrder();
		        },
		        {
		            scKey: $scope.settings.CommBankPublicApiKey,
		            amount: $scope.finalBankPrice,
		            operation: 'create.token',
		            name: $scope.Division,
		            description: $scope.theChoosenMembership.ServiceName

		        }
		    ).closeOnCompletion();
		    /**
		     * Handle the error response from the server call that
		     * failed to make a payment from the card token.
		     */
		    function apiPaymentErrorHandler() {
		        // re-enable the payment button, so the user can try again.
		        hostedPayments.enablePayBtn();
		        // TODO: Handle error
		    }
		}else{
			$(".onepage-wrapper .actions .commbank-buttonhp").removeClass('show');
		}

		if (paymentWayValue == 6) {
            $(".onepage-wrapper .actions .commbank-button").addClass('show');
            $(".onepage-wrapper .actions .commbank-button").on("click", function () {
                $scope.orderLoading = true;
                $('.payment-form .payment-status').empty();
                $('.payment-form, .loader-container-loader').addClass('loading');
                // Disable the submit button
                $(".onepage-wrapper .actions .commbank-button").attr("disabled", "disabled");
                // Generate a card token & handle the response
                SimplifyCommerce.generateToken({
                    key: $scope.settings.CommBankPublicApiKey,
                    card: {
                        number: $("#cc-number").val(),
                        cvc: $("#cc-cvc").val(),
                        expMonth: $("#cc-exp-month").val(),
                        expYear: $("#cc-exp-year").val()
                    }
                }, simplifyResponseHandler);
                // Prevent the form from submitting
                return false;
            });

            function simplifyResponseHandler(data) {
                // Remove all previous errors
                $(".error").remove();
                // Check for errors
                if (data.error) {
                    // Show any validation errors
                    if (data.error.code == "validation") {
                        var fieldErrors = data.error.fieldErrors,
                            fieldErrorsLength = fieldErrors.length,
                            errorList = "";
                        for (var i = 0; i < fieldErrorsLength; i++) {
                            errorList += "<div class='error'>Field: '" + fieldErrors[i].field +
                                         "' is invalid - " + fieldErrors[i].message + "</div>";
                        }

                        // console.log(errorList);
                        // Display the errors
                        $('.payment-form .payment-status').html('<div class="error-msg"></div>');
                        $('.payment-form .payment-status .error-msg').after('<div class="error-msg show">' + errorList + '</div>');
                    }
                    // Re-enable the submit button
                    $scope.orderLoading = false;
                    $(".onepage-wrapper .actions .commbank-button").removeAttr("disabled");
                } else {
                    // The token contains id, last4, and card type
                    var token = data["id"];
                    // Insert the token into the form so it gets submitted to the server
                    $('.payment-form .payment-status').append("<input type='hidden' name='simplifyToken' value='" + token + "' />");
                    // Submit the form to the server

                    $scope.token = token;
                    $scope.placeOrder();
                }
                $('.payment-form, .loader-container-loader').removeClass('loading');
            }
        }else{
            $(".onepage-wrapper .actions .commbank-button").removeClass('show');
        }
	});


	// Purchase Page
	$scope.lockMembership = false;
	$scope.onePageloading = false;


	$(".onepage-wrapper .actions .commbank-buttonhp").on('click', function(e){
		e.preventDefault();
		$('.payment-method .sections .section-title button').trigger('click');
	})

	if ( settings ) {
		$scope.settings = settings;
		// $scope.settings.CommBankHostedPayments = true;
	}

	if ( memberships ) {
		$scope.memberships = memberships;

		if ( $scope.memberships.length == 1 ) {
			$scope.lockMembership = true;
			$scope.theChoosenMembership = $scope.memberships[0];
			getFinalPrice($scope.theChoosenMembership.OriginalPrice);

			$scope.theChoosenMembershipDate = new Date();
			$scope.orderCardReccuring = ($scope.theChoosenMembership.Fibank != true) ? false : true;
			$scope.choosenMembership = true;
		}
	}


	$scope.$watch('mainPaymentWay', function (v) {
		if ( v == 'stripe' ) {
			$timeout(function() {
				$scope.paymentway = 9;
			})
			// $scope.$apply();
		}else if ( v == 'commbank' ){
			$timeout(function() {
				$scope.paymentway = 6;
			})
		}else if ( v == 'commbankhp' ){
			$timeout(function() {
				$scope.paymentway = 66;
			})
		}else{
			$scope.paymentway = '';
			$('.onepage-wrapper .actions .stripe-button').removeClass('show');
		}

	});

	$scope.theChoosenMembershipIsFree = false;
	$scope.getMembership = function(id){
		var result = $scope.memberships.filter(function (obj) {
			return obj.ServiceDefinitionID == id;
		});

		$scope.theChoosenMembership = result[0];
		$scope.orderCardReccuring = ($scope.theChoosenMembership.Fibank != true) ? false : true;

		if ( $scope.theChoosenMembership.OriginalPrice == 0 ){
			$scope.theChoosenMembershipIsFree = true;
			$scope.paymentway = 0;
		}else{
			$scope.theChoosenMembershipIsFree = false;
			$scope.paymentway = null;
			getFinalPrice($scope.theChoosenMembership.OriginalPrice);
		}
		$scope.choosenMembership = true;
	}

	function getFinalPrice(price){
		if (price.toString().indexOf(".") == -1 ) {
	        $scope.finalBankPrice = price + '00';
	    }else{
	        $scope.finalBankPrice = price.toString().split('.').join("");
	    }

	    $scope.finalBankPrice = parseInt($scope.finalBankPrice);
	}


	$scope.placeOrder = function(){

		$scope.onePageloading = true;
		var paymentProvider = '';

		if ( $scope.paymentway == 1 ) {
			paymentProvider = 'paylogin';
		}else if ( $scope.paymentway == 2 ){
			paymentProvider = 'credit_paydirect';
		}else if ( $scope.paymentway == 9 ){
			paymentProvider = 'stripe card';
		}else if ( $scope.paymentway == 6 ){
			paymentProvider = 'CommBank';
		}else if ( $scope.paymentway == 66 ){
			paymentProvider = 'CommBank';
		}else if ( $scope.paymentway == 0 ){
			paymentProvider = '0';
		}

		var startDate = new Date($scope.theChoosenMembershipDate);
		startDate.setHours(0,0,0,0);


		var dataObject = { 
			GymID: $scope.DivisionID, 
			Namespace: namespace, 
			model: { FirstName: $scope.FirstName, LastName: $scope.LastName, Email: $scope.Email, Password: $scope.Password, NewAccount: $scope.NewAccount, Telephone: $scope.Telephone, MembershipID: $scope.membershipId, PaymentProvider: paymentProvider, Token: $scope.token, MembershipID: $scope.theChoosenMembership.ServiceDefinitionID, Date: startDate, Note: $scope.Note, PromoCode: $scope.PromoCode, price: $scope.theChoosenMembership.OriginalPrice }
		};

		$http({
			method: 'POST',
			url: '/Membership/PurchaseAndRegister',
			data: dataObject
		}).success(function (data) {

			// console.log(data);

			if ( data.Key == 1 || data.Key == 2 || data.Key == 3 ){
				Swal.fire({
	                type: 'warning',
	                title: data.Value
	            })
			}else if ( data.Key == 0 ){
				var translated = $translateThis('Payment finished with success.');
				Swal.fire({
	                type: 'success',
                    title: translated
	            })
			}else if ( data == 'Error' ){
				var translated = $translateThis('buyError');
				Swal.fire({
	                type: 'warning',
	                title: translated
	            })
			}else if ( data == 'Recurring service exist!' ){
				var translated = $translateThis('Recurring service exist! OnePage');
				Swal.fire({
	                type: 'warning',
	                title: translated
	            })
			}else if ( data == 'succeeded' ){
				var translated = $translateThis('Payment finished with success.');
				Swal.fire({
	                type: 'success',
                    title: translated,
                    onAfterClose: (function () {
                        window.location.reload(true);
                    })
	            })
			}else{
				window.location.replace(data);
			}

			$scope.onePageloading = false;
		}).error(function () {
			$scope.onePageloading = false;			
		});
	}


	function getPrice(price, discount) {         
		var numVal1 = Number(price);
		var numVal2 = Number(discount);

		var totalValue = numVal1 * ( (100-numVal2) / 100 )
		return totalValue.toFixed(2);
	}

	$scope.Discount = 0;
	$scope.changePromoCode = function () {

		if ($scope.PromoCode.length > 3) {
			var dataObject = {
				Namespace: namespace,
				GymID: $scope.DivisionID,
				ClientID: -1,
				ServiceID: $scope.theChoosenMembership.ServiceDefinitionID,
				orderType: $scope.orderType,
				DateStart: $scope.theChoosenMembershipDate,
				PromoCode: $scope.PromoCode,
				Discount: $scope.Discount
			}
			// if (dataObject.GymID == undefined)
			//     dataObject.GymId = $scope.Model.GymId;
			// if ($scope.orderCardId == undefined && $scope.serviceDefinitionId != undefined)
			// 	dataObject.ServiceID = $scope.serviceDefinitionId;
			$http({
				method: 'POST',
				url: '/Membership/ValidatePromoCode',
				data: dataObject
			}).success(function (data) {
				$scope.promocodeFalse = false;
				if (data != 'false') {
					$scope.Discount = data.DiscountPercent;
					// if ($scope.orderCardId != undefined && $scope.serviceRealID == undefined)
					// 	$scope.serviceRealID = $scope.orderCardId;

					$scope.theChoosenMembership.OriginalPrice = getPrice($scope.theChoosenMembership.OriginalPrice, data.DiscountPercent)
					// getTermsForMembership();
				}else{
					$scope.promocodeFalse = true;
				}
			}).error(function () {
				// console.log('error');
			});
		}
	};

	function getTermsForMembership() {
		var dataObject = {
			Namespace: namespace,
			GymID: $scope.DivisionID,
			ClientID: -1,
			ServiceID: $scope.theChoosenMembership.ServiceDefinitionID,
			orderType: $scope.orderType,
			Discount: $scope.Discount
		}

		$http({
			method: 'POST',
			url: '/Membership/Terms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipTerms = data;
			$scope.theChoosenMembership.OriginalPrice = data.Price;
		}).error(function () {
			// console.log('error');
		});
	}


	$(window).on('load', function(){
		if ( $('.onepage-wrapper').length ) {
			$timeout(function() {
				if ( $scope.theChoosenMembership && $scope.theChoosenMembership.OriginalPrice == 0 ){
					$scope.theChoosenMembershipIsFree = true;
					$('#payment-free').prop("checked", true).trigger("click");
					$scope.paymentway = 0;
				}else{
					$scope.theChoosenMembershipIsFree = false;
				}
		    });
			$scope.matchingOnePagePassword = '';
			$('#Password, #ConfirmPassword').on('keyup', function () {
				if ($('#Password').val() == $('#ConfirmPassword').val()) {
					$('.validation-errors').html('');
					$scope.matchingOnePagePassword = 'ass';
				} else {
					var translated = $translateThis('notMaching');
					$('.validation-errors').html('<div class="section-valid"><p>' + translated + '</p></div>');
					$scope.matchingOnePagePassword = '';
				}

				$scope.$apply();
			});

			$('.header .logo').attr('href', '');

			if ( $('.payment-method .sections .section.active').length == 1 ){
				$('.payment-method .sections .section.active input[name="mainPaymentWay"]').prop('checked', true);
				$scope.mainPaymentWay = $('.payment-method .sections .section.active input[name="mainPaymentWay"]').val();
				$scope.$apply();
			}

			setTimeout(function() {
				$('#sc-style-modal').remove()
			}, 3000);
		}
	})

}]);

membershipApp
.directive('datepicker', ['$translate', function ($translate) {
	return {
		link: function ($scope, el, attr, ngModel) {

			function setCookie(key, value) {
				var val = value;
				var expires = new Date();
				expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
				document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
				if (val != "true") {
					$('body').addClass('pound-currency');
				} else {
					$('body').removeClass('pound-currency');
				}
			}

			function getCookie(key) {
				var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
				return keyValue ? keyValue[2] : null;
			}

			var today = new Date();
			var datepicker = $(el);
			var lastDate = getCookie('setDate');

			datepicker.datepicker({
				changeMonth: true,
				changeYear: true,
				yearRange: "1920:2040",
				numberOfMonths: 1,
				onSelect: function (dateText, inst) {
					$scope.currentLang = $translate.proposedLanguage() || $translate.use();
					var date = $(this).val();

					if ($scope.gym[0].Culture != 'en-US') {
						var res = date.split("/");
						var date = res[1] + '/' + res[0] + '/' + res[2];
					}
					$scope.cardStartDate = new Date(date);
					$scope.membershipStartDate = $scope.cardStartDate;

					if ($('.section-authorize').length && !$('#RegBirthdayVal').is(':checked')) {
						$('#RegBirthdayVal').trigger('click');
					}
					
					if ( $('.onepage-wrapper').length ) {
						$scope.theChoosenMembershipDate = $scope.cardStartDate;
					}
					$scope.$apply();
				}
			});
			$scope.currentLang = $translate.proposedLanguage() || $translate.use();

			if ($('.membershipbuy-wrapper').length) {

				if (lastDate != null && lastDate != '') {

					if ($scope.gym[0].Culture != 'en-US') {
						var res = lastDate.split('/');
						var newDate = res[1] + '/' + res[0] + '/' + res[2];
						var newLastDate = new Date(newDate);
					}
					else {
						var newLastDate = new Date(lastDate);
					}

					datepicker.datepicker("setDate", newLastDate);
					if (datepicker.parents('.membersip-card').is('.checked')) {
						setCookie('setDate', '');
					}
				} else {
					datepicker.datepicker("option", "minDate", 0);
					datepicker.datepicker("setDate", today);
				}
			}

			if ( $('.onepage-wrapper').length ) {
				datepicker.datepicker("option", "minDate", 0);
				datepicker.datepicker("setDate", today);
				$scope.theChoosenMembershipDate = today;

				if ( $scope.lockMembership ) {
					datepicker.datepicker("option", "maxDate", 20);	
				}
			}
			
			if ($('.section-authorize').length) {
				datepicker.datepicker("option", "maxDate", 0);
			}

			datepicker.next('i').on('click', function () {
				datepicker.datepicker('show');
			});


			if ($scope.currentLang == 'en') {
				datepicker.datepicker("option", $.datepicker.regional['en']);
			}else if ($scope.currentLang == 'es' || $scope.currentLang == 'esc'){
				datepicker.datepicker("option", $.datepicker.regional['es']);
			}else {
				datepicker.datepicker("option", $.datepicker.regional['bg']);
			}

			if ( $scope.gym[0].Culture == 'en-US' ) {
				datepicker.datepicker("option", "dateFormat", 'mm/dd/yy');
			}else{
				datepicker.datepicker("option", "dateFormat", 'dd/mm/yy');
			}

			$(document).on('click', '.lang-nav li a', function () {
				var lang = $(this).data('lang');

				if (lang == 'en') {
					datepicker.datepicker("option", $.datepicker.regional['en']);
				}else if ($scope.currentLang == 'es' || $scope.currentLang == 'esc'){
					datepicker.datepicker("option", $.datepicker.regional['es']);
				} else {
					datepicker.datepicker("option", $.datepicker.regional['bg']);
				}

				if ( $scope.gym[0].Culture == 'en-US' ) {
					datepicker.datepicker("option", "dateFormat", 'mm/dd/yy');
				}else{
					datepicker.datepicker("option", "dateFormat", 'dd/mm/yy');
				}
			})
		}
	};
}])
.controller('MembershipChangePaymentMethodController', ['$scope', '$http', '$timeout', '$translate', '$filter', function ($scope, $http, $timeout, $translate, $filter) {
	$scope.alerting = false;
	var $translateThis = $filter('translate');
	$scope.loading = false;


	if ( lang ){
		$translate.use(lang);
	}

	$scope.getClientServices = function () {
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: client.ClientID
		}

		$http({
			method: 'POST',
			url: '/Membership/GetClientServices',
			data: dataObject
		}).success(function (data) {
			$scope.clientServices = data;
			$scope.PaymentMethods.forEach(function (el) {
				var el = el;
				var result = $.grep($scope.clientServices, function (e) { return e.PaymentMethodID == el.ID; });

				if (result.length > 0) {
					el.ServiceName = result[0].ServiceName;
				}
			});
		}).error(function () {
		});
	}

	$scope.getPaymentMethods = function () {
	    if (client != null && client != undefined) {
	        var dataObject = {
	            Namespace: namespace,
	            GymID: gymid,
	            ClientId: client.ClientID
	        }

	        $http({
	            method: 'POST',
	            url: '/Membership/GetPaymentMethods',
	            data: dataObject
	        }).success(function (data) {
	            $scope.PaymentMethods = data;
	            $scope.getClientServices();
	        }).error(function () {
	        });
	    }
	}
	$scope.getPaymentMethods();


	$scope.setDefaultPaymentMethod = function (id) {
		var paymentId = id;
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: client.ClientID,
			Id: paymentId
		}

		$http({
			method: 'POST',
			url: '/Membership/SetDefaultPaymentMethod',
			data: dataObject
		}).success(function (data) {
			var data = data;
			if (data == true) {
				$('.paymentmethod-item[data-paymentid="' + paymentId + '"]').addClass('default').siblings('.default').removeClass('default');
			}
			$scope.closePopup('setDefaultPaymentMethod');
		}).error(function () {
		});
	}

	// RemovePaymentMethod(int Id, int ClientID, int GymID, string Namespace)

	$scope.removePaymentMethod = function (id) {
		$scope.loading = true;
		var paymentId = id;
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: client.ClientID,
			Id: paymentId
		}

		$http({
			method: 'POST',
			url: '/Membership/RemovePaymentMethod',
			data: dataObject
		}).success(function (data) {
			var data = data;
			$scope.loading = false;
			var translated = $translateThis('Payment method removed!');
			Swal.fire({
                type: 'warning',
                title: translated,
                onAfterClose: (function () {
					$scope.closePopup('removePaymentMethod');
                    window.location.reload(true);
                })
            })
		}).error(function (err) {
			$scope.loading = false;
			Swal.fire({
                type: 'warning',
                title: err
            })
		});
	}

	$scope.addPaymentMethod = function (token) {
		$scope.loading = true;

		var newPaymentMethodModel = { PaymentProvider: $scope.mainPaymentWay, ClientID: client.ClientID, CardID: client.CardID }

		if ( token ) {
			if ( $scope.mainPaymentWay == 'STRIPE CARD' ) {
				token = token.id;
			}
			var newPaymentMethodModel = { PaymentProvider: $scope.mainPaymentWay, ClientID: client.ClientID, CardID: client.CardID, Token: token }			
		}
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			model: newPaymentMethodModel
		}

		$http({
			method: 'POST',
			url: '/Membership/AddPaymentMethod',
			data: dataObject
		}).success(function (data) {
			var data = data;
			if (data == 'error' || data == 'Error') {
				var currentHref = window.location;
				var href = currentHref.origin + '/membership/errorPurchase?nameSpace=' + namespace + '&gymId=' + gymid;
				if ( isMobile == true ) {
					href += '&isMobile=true';
				}
				window.location.replace(href);
			}else if(data == 'done'){
				var translated = $translateThis('Payment method added!');
				Swal.fire({
	                type: 'success',
                    title: translated,
                    onAfterClose: (function () {
                        window.location.reload(true);
                    })
	            })
			} else {
				window.location.replace(data);
			}
			$scope.loading = false;
		}).error(function () {
		});
	}

	$('.popup-wrapper[data-id="setDefaultPaymentMethod"] .btn.agree').on('click', function () {
		var id = $(this).data('id');
		$scope.setDefaultPaymentMethod(id);
	})

	$('.popup-wrapper[data-id="removePaymentMethod"] .btn.agree').on('click', function () {
		var id = $(this).data('id');
		$scope.removePaymentMethod(id);
	})

	$('.popup-wrapper[data-id="addPaymentMethod"] .btn.agree').on('click', function () {
		$scope.addPaymentMethod();
	})

	$scope.$watch('mainPaymentWay', function (v) {
		var paymentValue = v;
		$scope.paymentway = '';

		// if (paymentValue == 'fibank'){
		//     $scope.paymentway = 8;
		// }else{
		// }

		if (paymentValue == 'STRIPE CARD') {

			$('.step-actions .stripe-button').addClass('show');
			// Create a Stripe client.
			var stripe = Stripe($scope.membershipSettings.StripePublishKey);
			// Create an instance of Elements.
			var elements = stripe.elements();
			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
			  base: {
				color: '#32325d',
				lineHeight: '18px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
				  color: '#aab7c4'
				}
			  },
			  invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			  }
			};


			// Create an instance of the card Element.
			var card = elements.create('card', {style: style});

			// Add an instance of the card Element into the `card-element` <div>.
			card.mount('#card-element');

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function(event) {
				var displayError = document.getElementById('card-errors');
			  	if (event.error) {
					displayError.textContent = event.error.message;
			  	} else {
					displayError.textContent = '';
			  	}
			});

			// Handle form submission.
			var form = document.getElementById('payment-form');

			$('.stripe-button').on('click', function(e){
				e.preventDefault();
				if ($scope.loading == false || $scope.loading == undefined) {
				    $scope.loading = true;
				    stripe.createToken(card).then(function (result) {
				        if (result.error) {
				            // Inform the user if there was an error.
				            var errorElement = document.getElementById('card-errors');
				            errorElement.textContent = result.error.message;
				            $scope.loading = false;
				        } else {
				            // Send the token to your server.
				            var token = result.token
				            $scope.addPaymentMethod(token);
				        }
				    });
				}
			})
		}else{
			$('.step-actions .stripe-button').removeClass('show');
		}

		if (paymentValue == 'paysafe') {
			$('.step-actions .paysafe-button').addClass('show');
			$scope.getPaymentMethods();
			if (!$scope.paySafeInit) {
				if ($scope.membershipSettings.PaySafeFrontEndKey != '') {
					$scope.paySafeInit = true;
					// Base64 encoded version the Single-use Token API key.
					// Create the key below by concatenating the API username and password
					// separated by a colon and Base64-encoding the result
					var apiKey = $scope.membershipSettings.PaySafeFrontEndKey;
					var Enviroment = "TEST";
					if ($scope.membershipSettings.PaySafeLive == true)
						Enviroment = "LIVE";
					var options = {

						// select the Paysafe test / sandbox environment
						environment: Enviroment,

						// set the CSS selectors to identify the payment field divs above
						// set the placeholder text to display in these fields
						fields: {
							cardNumber: {
								selector: "#cardNumber",
								placeholder: "Card number"
							},
							expiryDate: {
								selector: "#expiryDate",
								placeholder: "Expiry date"
							},
							cvv: {
								selector: "#cvv",
								placeholder: "CVV"
							}
						}
					};

					paysafe.fields.setup(apiKey, options, function (instance, error) {
						$('.step-actions .paysafe-button').on('click', function (event) {
							$scope.loading = true;
							instance.tokenize(function (instance, error, result) {
								if (error) {
									alert(JSON.stringify(error));
									$scope.loading = false;
								} else {
									var token = result.token
									$scope.addPaymentMethod(token);
								}
							});
						})
					});
				}
			}
		} else {
			$scope.paysafeinit = false;
		}
	});
}])
.controller('MembershipBuyController', ['$scope', '$http', '$timeout', '$translate', function ($scope, $http, $timeout, $translate) {
	var today = new Date();
	$scope.paySafeInit = false;
	$scope.newCard = false;
	$scope.currentStep = 1;
	$scope.orderType = 'PURCHASE';
	$scope.PromoCode = '';
	$scope.Discount = 0;
	$scope.promocodeFalse = false;
	$scope.hasRecurring = false;

	if ( lang ){
		$translate.use(lang);
	}

	$scope.chooseCard = function (val) {
		$scope.hasRecurring = false;
		$('.step-memberships .step-actions .next').addClass('disabled');
		var result = $.grep($scope.membershipCards, function (e) { return e.ServiceDefinitionID == val; });

		$scope.orderCardId = result[0].ServiceDefinitionID;
		$scope.orderCardPrice = result[0].OriginalPrice;
		$scope.orderCardName = result[0].ServiceName;
		$scope.orderCardReccuring = (result[0].Fibank != true) ? false : true;
		$scope.orderCardPaysafe = (result[0].IsPaySafe != true) ? false : true;
		$scope.orderAdditionDescription = result[0].AdditionalDescription;
		$scope.orderAdditionDesc = ($scope.orderAdditionDescription != null) ? true : false;
		$scope.cardStartDate = today;
		$scope.newCard = true;

		if ( result[0].Recurring == true ) {
			$http({
				method: 'POST',
				url: '/Membership/HasRecurring',
				data: { Namespace: $scope.Model.Namespace, GymID: $scope.Model.GymId }
			}).success(function (data) {
				if ( data == 'True' ) {
					$scope.hasRecurring = true;
				}else{
					$scope.hasRecurring = false;
					$('.step .step-actions .next').removeClass('disabled');
				}
			}).error(function () {
			});
		}else{
			$('.step .step-actions .next').removeClass('disabled');
		}

		var data = $('.step .membersip-card[data-memid="mem' + val + '"]').find('.info-action input').val();
	}

	$scope.changePromoCode = function () {

		if ($scope.PromoCode.length > 3) {
			var dataObject = {
				Namespace: $scope.Model.Namespace,
				GymID: $scope.gymZoneId,
				ClientID: $scope.clientInfo.ClientID,
				ServiceID: $scope.orderCardId,
				orderType: $scope.orderType,
				DateStart: $scope.cardStartDate,
				PromoCode: $scope.PromoCode,
				Discount: $scope.Discount
			}
			if (dataObject.GymID == undefined)
			    dataObject.GymId = $scope.Model.GymId;
			if ($scope.orderCardId == undefined && $scope.serviceDefinitionId != undefined)
				dataObject.ServiceID = $scope.serviceDefinitionId;
			$http({
				method: 'POST',
				url: '/Membership/ValidatePromoCode',
				data: dataObject
			}).success(function (data) {
				$scope.promocodeFalse = false;
				if (data != 'false') {
					$scope.Discount = data.DiscountPercent;
					if ($scope.orderCardId != undefined && $scope.serviceRealID == undefined)
						$scope.serviceRealID = $scope.orderCardId;
					getTermsForMembership();
				}else{
					$scope.promocodeFalse = true;
				}
			}).error(function () {
				// console.log('error');
			});
		}
	};

	$scope.changeStep = function (n) {
		$scope.currentStep = n;
		$scope.Discount = 0;
		$scope.PromoCode = '';
		// $scope.hasRecurring = false;
		if (n == 2) {
			setTimeout(function () {
				if (membershipID != null) {
					var memId = Number(membershipID);
					$scope.chooseCard(memId);
					$('.step .membersip-card').hide();
					$('input[id="radio-card-' + memId + '"]').parents('.membersip-card').show().addClass('checked');
					$('input[id="radio-card-' + memId + '"]').trigger('click');

					$('.membershipbuy-wrapper').removeClass('loading');
				}
			}, 50);
		}

		if (n == 3) {
			var date = $('.step .membersip-card.checked .more-info .info-action input').val();

			if ($scope.gym[0].Culture != 'en-US') {
				var res = date.split('/');
				var newDate = res[1] + '/' + res[0] + '/' + res[2];
				$scope.cardStartDate = new Date(newDate);
			}
			else {
				$scope.cardStartDate = new Date(date);
			}


			var dataObject = {
				Namespace: $scope.Model.Namespace,
				GymID: $scope.Model.GymId,
				ClientID: $scope.clientInfo.ClientID,
				ServiceID: $scope.orderCardId,
				orderType: $scope.orderType,
				DateStart: $scope.cardStartDate,
				PromoCode: $scope.PromoCode,
				Discount: $scope.Discount
			}
			if ($scope.orderCardId == undefined && !$scope.orderType == "PAY")
				dataObject.ServiceID = $scope.serviceDefinitionId;
			$http({
				method: 'POST',
				url: '/Membership/Terms',
				data: dataObject
			}).success(function (data) {
				$scope.orderCardPrice = data.Price;
			}).error(function () {
				// console.log('error');
			});

			if ( $scope.Model.Namespace == 'athletic') {
				fbq('track', 'AddToCart');
			}

			var numItems = $('.payment-method .section.active').length

			if ( numItems == 1 ) {
				$('.payment-method .section.active .section-title input').trigger('click');
				$scope.mainPaymentWay = 'epay';
				$scope.$apply();
			}

			// $('.payment-method .section')
		}

	}

	// Get Gyms
	$scope.getGyms = function () {
		var dataObject = {
			Namespace: $scope.Model.Namespace
		}
		$http({
			method: 'POST',
			url: '/Membership/GetGyms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipGyms = data;

			if ($scope.membershipGyms.length == 1) {
				$scope.getCards($scope.membershipGyms[0].GymID);
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.getGyms();


	$('.tooltip i').on('click', function () {
		$(this).parent('.tooltip').toggleClass('show');
	})

	$scope.goCheckout = function () {
		var self = $(this);
	}

	// Get Cards
	$scope.getCards = function (id) {
		$('body').removeClass('loaded');
		$scope.gymZoneId = id;
		var result = $scope.membershipGyms.filter(function (obj) {
			return obj.GymID == $scope.gymZoneId;
		});

		$scope.gymZoneName = result[0].GymName;

		var dataObject = {
			Namespace: $scope.Model.Namespace,
			GymID: $scope.gymZoneId
		}
		
		$http({
			method: 'POST',
			url: '/Membership/GetCards',
			data: dataObject
		}).success(function (data) {
			var data = data;
			$scope.membershipCards = data;
			$scope.changeStep(2);
			$scope.hasRecurring = false;

			$('body').addClass('loaded');
		}).error(function () {
			// console.log('error');
		});
	}

	// $scope.getCards();

	// Get Terms
	var url = window.location.href;
	var serviceId = url.split('ServiceID=');
	$scope.clientInfo = client;

	function getTermsForMembership() {
		var dataObject = {
			Namespace: $scope.Model.Namespace,
			GymID: $scope.Model.GymId,
			ClientID: $scope.clientInfo.ClientID,
			ServiceID: $scope.serviceRealID,
			orderType: $scope.orderType,
			Discount: $scope.Discount
		}
		if ($scope.orderCardId == undefined && !$scope.orderType == "PAY" && dataObject.ServiceID != undefined)
			dataObject.ServiceID = $scope.serviceDefinitionId;

		$http({
			method: 'POST',
			url: '/Membership/Terms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipTerms = data;
			$scope.orderCardPrice = data.Price;

			if ($scope.membershipTerms == 'unactive service') {
				$('.invalid-card').addClass('show');
			} else {
				$('.invalid-card').removeClass('show');
				$("#membershipStartDate").datepicker('option', 'minDate', new Date($scope.membershipTerms.MinimalStartingDate));
			}
		}).error(function () {
			// console.log('error');
		});
	}


	if (serviceId.length > 1) {
		var serviceVarId = serviceId[1].split('&');
		$scope.serviceRealID = serviceVarId[0];
		$scope.orderType = serviceVarId[2].split('=')[1];
		$scope.serviceDefinitionId = serviceVarId[1].split('=')[1];

		getTermsForMembership();
		// $scope.getTerms = function () {
		// }

		// $scope.getTerms();
	}

	// Get Settings
	$scope.getSettings = function () {
		var dataObject = {
		    Namespace: $scope.Model.Namespace,
		    GymID: $scope.DivisionID
		}
		$http({
			method: 'POST',
			url: '/Membership/GetSettings',
			data: dataObject
		}).success(function (data) {
			$scope.membershipSettings = data;
			$scope.countriesSettings = data.Countries;

			if ($scope.membershipSettings.Culture == 'bg-BG') {
				$scope.currency = 'лв.';
			}else if($scope.membershipSettings.Culture.includes('-ES')){
				$scope.currency = 'eur';
			}else {
				$scope.currency = '$';
			}

			if (customCurrency) {
				$scope.currency = customCurrency;
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.getSettings();

	$scope.getPaymentMethods = function () {
	    if (client != null && client != undefined) {
	        var dataObject = {
	            Namespace: $scope.Model.Namespace,
	            GymID: $scope.Model.GymId,
	            ClientId: $scope.clientInfo.ClientID
	        }

	        $http({
	            method: 'POST',
	            url: '/Membership/GetPaymentMethods',
	            data: dataObject
	        }).success(function (data) {
	            $scope.clientPaymentCards = data;
	        }).error(function () {
	        });
	    }
	}

	$scope.getPaymentMethods();

	function is_url(str)
	{
	  regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
	  regexp1 = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	        if (regexp1.test(str))
	        {
	          return true;
	        }
	        else
	        {
	          return false;
	        }
	}

	// .
	var paymentMethodsArray = new Array("", "paylogin", "credit_paydirect", "PaySafe Card", "PAYSAFE SEPA", "PAYSAFE ACH", "PAYSAFE EFT", "PAYSAFE BACKS", "Fibank", "STRIPE CARD");
	$scope.placeOrder = function () {
		$scope.loading = true;
		$('.steps-body .step-actions button.pay').addClass('disabled');
		var gymId = $scope.Model.GymId;
		var token = ''
		var paymentProvider = paymentMethodsArray[$scope.paymentway];
		$scope.paymentError = false;
		$scope.paymentReccuringError = false;

		if (paymentProvider == 'PaySafe Card') {
			var token = $scope.tokenPaySafe;
		}

		if (paymentProvider == 'STRIPE CARD') {
		    var token = $scope.tokenStripe.id;
		}

		if (!$scope.newCard) {
			var price = $scope.membershipTerms.Price;

			if ($scope.membershipTerms.CanChooseDate != false) {
				var startDate = moment($scope.membershipStartDate);
			} else {
				var startDate = $scope.membershipTerms.MinimalStartingDate;
			}

			var startDate = new Date(startDate);
		} else {
			var price = $scope.orderCardPrice;
			var serviceRealId = $scope.orderCardId;
			var startDate = $scope.cardStartDate;
			gymId = $scope.gymZoneId;
		}

		var orderType = $scope.orderType;

		if (paymentProvider == 'Fibank') {
			orderType = 'INITIAL PAYMENT';
		}

		// Brand New Membership
		var dateObjectOrder = { paymentMethodID: $scope.paymentway, paymentProvider: paymentProvider, serviceName: $scope.orderCardName, serviceDefinitionID: serviceRealId, clientID: $scope.clientInfo.ClientID, cardId: $scope.clientInfo.CardID, price: price, dateStart: startDate, token: token, orderType: orderType, AccountHolderName: $scope.accountHolderName, AccountNumber: $scope.accountNumber, RoutingNumber: $scope.routingNumber, TransitNumber: $scope.transitNumber, InstitutionID: $scope.institutionID, Iban: $scope.iban, Bic: $scope.bic, AccountNumber: $scope.accountNumber, SortCode: $scope.sortCode, RecipentName: $scope.recipentName, Telephone: $scope.telephone, Country: $scope.country, State: $scope.state, Zip: $scope.zip, City: $scope.city, Street: $scope.street, PromoCode: $scope.PromoCode }

		// Old Membership
		if ($scope.serviceRealID > 0 && ($scope.orderType == "RENEW" || $scope.orderType == "PAY")) {
			dateObjectOrder = { paymentMethodID: $scope.paymentway, paymentProvider: paymentProvider, serviceName: $scope.membershipTerms.ServiceName, serviceDefinitionID: $scope.serviceDefinitionId, clientID: $scope.clientInfo.ClientID, cardId: $scope.clientInfo.CardID, price: price, dateStart: startDate, token: token, orderType: $scope.orderType, serviceID: $scope.serviceRealID, AccountNumber: $scope.accountNumber, RoutingNumber: $scope.routingNumber, TransitNumber: $scope.transitNumber, InstitutionID: $scope.institutionID, Iban: $scope.iban, Bic: $scope.bic, AccountNumber: $scope.accountNumber, SortCode: $scope.sortCode, RecipentName: $scope.recipentName, Telephone: $scope.telephone, Country: $scope.country, State: $scope.state, Zip: $scope.zip, City: $scope.city, Street: $scope.street, PromoCode: $scope.PromoCode }
		}

		if ($scope.paymentway == 'usedcardStripe') {
			dateObjectOrder.paymentMethodID = 9;
			dateObjectOrder.paymentProvider = 'STRIPE CARD';
			dateObjectOrder.selectedPaymentMethodID = $scope.preChoosedCardStripe;
		}

		if ($scope.paymentway == 'usedcardPaysafe') {
			dateObjectOrder.paymentMethodID = 3;
			dateObjectOrder.paymentProvider = 'PaySafe Card';
			dateObjectOrder.selectedPaymentMethodID = $scope.preChoosedCardPaysafe;
		}

		if ($scope.paymentway == 'usedcardFibank') {
			dateObjectOrder.paymentMethodID = 8;
			dateObjectOrder.paymentProvider = 'Fibank';
			dateObjectOrder.selectedPaymentMethodID = $scope.preChoosedCardFibank;
		}

		var dataObject = {
			Namespace: $scope.Model.Namespace,
			GymID: gymId,
			order: dateObjectOrder
		}

		$http({
			method: 'POST',
			url: '/Membership/PlaceOrder',
			data: dataObject
		}).success(function (data) {
			var currentHref = window.location;

			if ( data == 'succeeded'){
				var href = currentHref.origin + '/membership/SuccessPurchase?nameSpace=' + $scope.Model.Namespace + '&gymId=' + gymId;
				if ( isMobile == true ) {
					href += '&isMobile=true';
				}
				window.location.replace(href);
			}else if ( data == 'Recurring service exist!' ){
				$scope.paymentReccuringError = true;
			}else if ( data == 'error' || data == 'Object reference not set to an instance of an object.' || data == 'Sequence contains more than one element' || data == 'Your card was declined.' || !is_url(data) ){
				$scope.paymentError = true;
			}else{
				$('.steps-body .step-actions button.pay').removeClass('disabled');
				window.location.replace(data);
			}

			$scope.loading = false;
		}).error(function () {
			$('.steps-body .step-actions button.pay').removeClass('disabled');
			$scope.loading = false;
		});

		// PlaceOrder
	}

	$scope.$watch('paymentway', function (v) {
		var paymentWayValue = v;

		if (paymentWayValue == '9') {

			$('.step-actions .stripe-button').addClass('show');
			// Create a Stripe client.
			var stripe = Stripe($scope.membershipSettings.StripePublishKey);
			// Create an instance of Elements.
			var elements = stripe.elements();
			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
			  base: {
				color: '#32325d',
				lineHeight: '18px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
				  color: '#aab7c4'
				}
			  },
			  invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			  }
			};


			// Create an instance of the card Element.
			var card = elements.create('card', {style: style});

			// Add an instance of the card Element into the `card-element` <div>.
			card.mount('#card-element');

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function(event) {
				var displayError = document.getElementById('card-errors');
			  	if (event.error) {
					displayError.textContent = event.error.message;
			  	} else {
					displayError.textContent = '';
			  	}
			});

			// Handle form submission.
			var form = document.getElementById('payment-form');

			$('.stripe-button').on('click', function(e){
			    e.preventDefault();
			    if ($scope.loading == false || $scope.loading == undefined) {
			        $scope.loading = true;
			        stripe.createToken(card).then(function (result) {
			            if (result.error) {
			                // Inform the user if there was an error.
			                var errorElement = document.getElementById('card-errors');
			                errorElement.textContent = result.error.message;
			                $scope.loading = false;
			            } else {
			                // Send the token to your server.
			                $scope.tokenStripe = result.token
			                $scope.placeOrder();
			            }
			        });
			    }
			})
		}else{
			$('.step-actions .stripe-button').removeClass('show');
		}

		if (paymentWayValue == '3') {
			$('.step-actions .paysafe-button').addClass('show');
			if (!$scope.paySafeInit) {
				if ($scope.membershipSettings.PaySafeFrontEndKey != '') {
					$scope.paySafeInit = true;
					// Base64 encoded version the Single-use Token API key.
					// Create the key below by concatenating the API username and password
					// separated by a colon and Base64-encoding the result
					var apiKey = $scope.membershipSettings.PaySafeFrontEndKey;
					var Enviroment = "TEST";
					if ($scope.membershipSettings.PaySafeLive == true)
						Enviroment = "LIVE";
					var options = {

						// select the Paysafe test / sandbox environment
						environment: Enviroment,

						// set the CSS selectors to identify the payment field divs above
						// set the placeholder text to display in these fields
						fields: {
							cardNumber: {
								selector: "#cardNumber",
								placeholder: "Card number"
							},
							expiryDate: {
								selector: "#expiryDate",
								placeholder: "Expiry date"
							},
							cvv: {
								selector: "#cvv",
								placeholder: "CVV"
							}
						}
					};

					paysafe.fields.setup(apiKey, options, function (instance, error) {
						$('.step-actions .paysafe-button').on('click', function (event) {
							instance.tokenize(function (instance, error, result) {
								if (error) {
									alert(JSON.stringify(error));
								} else {
									$scope.tokenPaySafe = result.token
									$scope.placeOrder();
								}
							});
						})
					});
				}
			}
		} else {
			$scope.paysafeinit = false;
			$('.step-actions .paysafe-button').removeClass('show');
		}

		$('#placeOrder input.inputField').val('');
	});

	$scope.$watch('mainPaymentWay', function (v) {
		var paymentValue = v;
		$scope.paymentway = '';
		$('.payment-method .sections .section-title input[value="' + paymentValue + '"]')
			.parents('.section')
			.addClass('active')
			.siblings('.active')
			.removeClass('active');
	});

	$(window).on('load', function () {
		if (selectedGym != null) {
			$('.membershipbuy-wrapper').addClass('loading');
			setTimeout(function () {
				var id = Number(selectedGym);
				$scope.getCards(id);
			}, 500);
		}
	});

}]);


membershipApp.controller('ScheduleController', ['$scope', '$http', '$timeout', '$translate', '$filter', '$compile', function ($scope, $http, $timeout, $translate, $filter, $compile) {

	$scope.text = 'me@example.com';
	$scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	// Default variables

	var now = new Date();
	var dd = now.getDate();
	var mm = now.getMonth() + 1;
	var yyyy = now.getFullYear();
	var nextYear = now.getFullYear() + 1;

	$scope.visitArea = 0;
	$scope.visitInstructor = 0;
	$scope.nameInstructor;
	$scope.choosenInstructor = false;
	$scope.filterActivity = filterActivity;
	$scope.nameActivity;
	$scope.choosenActivity = false;
	$scope.modalLoading = false;
	$scope.activityId = null;
	$scope.smodal = {paymentMethod: null, email: ''};
	// if ( lang == null ){
	// 	lang = 'en';
	// }


	if ( lang ){
		$translate.use(lang);
	}else{
		lang = $translate.proposedLanguage() || $translate.use();
	}

	$scope.lang = lang;

	$scope.paymentMethods = new Array("OnSide", "Membership", "Sodexo", "MultiSport", "Voucher", "EPay", "PaySafe");

	if (settings) {
		$scope.classSettings = settings
	}

	if (dd < 10) {
		dd = '0' + dd
	}

	if (mm < 10) {
		mm = '0' + mm
	}

	today = mm + '/' + dd + '/' + yyyy;
	todayInOneYear = mm + '/' + dd + '/' + nextYear;

	var schedule_from = $("#schedule_from");
	var schedule_to = $("#schedule_to");
	$scope.scheduleStartDate = today;
	$scope.scheduleEndDate = todayInOneYear;

	if ( $scope.mobileApp ){
		$scope.scheduleStartDate = new Date(today);
		$scope.scheduleEndDate = new Date(todayInOneYear);
	}

	function findElement(arr, propName, propValue) {
		for (var i = 0; i < arr.length; i++)
			if (arr[i][propName] == propValue)
				return arr[i];
		// will return undefined if not found; you could return a default instead
	}


	if (clientModel) {
		$scope.client = clientModel.Client;
	}

	$scope.getClientServices = function () {
		var dataObject = {
			Namespace: namespace,
			Email: $scope.client.Email,
			datestart: $scope.scheduleStartDate,
			dateend: $scope.scheduleEndDate
		}
		$http({
			method: 'POST',
			url:'/ScheduleV2/GetClientSchedule',
			data: dataObject
		}).success(function (data) {
			console.log(data);
			if ( data.length == 0 ) {
				$scope.noEvents = true;
				$scope.clientSchedule = {};
			}
			else{
				var today = new Date();
				$scope.testData = [];
				angular.copy(data, $scope.testData);
				for (var i = 0; i < $scope.testData.length; ++i) {
					var DateNewDate = new Date($scope.testData[i]['Date']);
					var DateNewDateEnd = new Date($scope.testData[i]['DateEnd']);

					var convertedDate = DateNewDate.toString();
					var convertedDateEnd = DateNewDateEnd.toString();
					var x = findElement($scope.schedule_areas, "AreaID", $scope.testData[i]['AreaID']);

					$scope.testData[i]['NewDate'] = new Date(convertedDate);
					$scope.testData[i]['NewDateEnd'] = new Date(convertedDateEnd);
					if (x != undefined && x['Name'] != undefined)
					    $scope.testData[i]['AreaName'] = x['Name'];

				}

				$scope.testData = $scope.convertTo($scope.testData, 'Date', true);

				$scope.clientSchedule = {};
				Object.keys($scope.testData).sort().forEach(function (key) {
					$scope.clientSchedule[key] = $scope.testData[key];
				});
			}


		}).error(function () {

		});
	}

	$scope.beforLeaveEvent = function(visitDate, visitId) {
		$scope.currentVisitDate = visitDate;
		$scope.currentVisitID = visitId;
		$('#shcedule-popup').addClass('show');
		$('#shcedule-popup .popup').addClass('show');
	}

	$scope.leaveEvent = function () {
		var now = new Date();

		var dateBeforeCancel = new Date($scope.currentVisitDate);
		dateBeforeCancel.setHours(dateBeforeCancel.getHours() - $scope.classSettings.HoursBeforeCanceling);

		if (now < dateBeforeCancel) {
			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				Id: $scope.currentVisitID,
				ClientID: $scope.client.ClientID
			}

			$http({
				method: 'POST',
				url: '/api/private/leaveEvent',
				data: dataObject
			}).success(function (data) {
				if (data == true) {
					$('#shcedule-popup .popup-body').addClass('show-success');
					$scope.getClientServices();
				}else{
					$('#shcedule-popup .popup-body').addClass('show-error');
				}
			}).error(function () {
				$('#shcedule-popup .popup-body').addClass('show-error');
			});
		} else {
			$('#shcedule-popup .popup-body').addClass('show-error');
		}
	}

	$scope.getEventsType = function(dgymID){
		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetPublicEvents?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_activities = data;
		}).error(function () {

		});
	}
	$scope.getEventsType();
 

	// Get Schedule

	$scope.getSchedule = function (from, to, dgymID, dontUpdateActInstr) {
		var updateActInstr = true;

		if ( dontUpdateActInstr != undefined ){
			updateActInstr = false;
		}

		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			GymID: gymid,
			Namespace: namespace,
			DateStart: $scope.scheduleStartDate,
			DateEnd: $scope.scheduleEndDate,
			AreaID: $scope.visitArea,
			InstructorID: $scope.visitInstructor,
			Private: true,
			PublicEventID: $scope.activityId
		}

		$http({
			method: 'POST',
			url: '/api/public/GetSchedule',
			data: dataObject
		}).success(function (data) {
			var today = new Date();
			$scope.testData = [];
			var currentActivities = [];
			var currentInstructors = [];
			angular.copy(data, $scope.testData);
			for (var i = 0; i < $scope.testData.length; ++i) {
				var DateNewDate = new Date($scope.testData[i]['Date']);
				var DateNewDateEnd = new Date($scope.testData[i]['DateEnd']);

				var convertedDate = DateNewDate.toString();
				var convertedDateEnd = DateNewDateEnd.toString();
				var x = findElement($scope.schedule_areas, "AreaID", $scope.testData[i]['AreaID']);

				$scope.testData[i]['NewDate'] = new Date(convertedDate);
				$scope.testData[i]['NewDateEnd'] = new Date(convertedDateEnd);
				if (x != undefined && x['Name'] != undefined)
				    $scope.testData[i]['AreaName'] = x['Name'];

				var testDateBeforeBooking = new Date(convertedDate);
				testDateBeforeBooking.setHours(testDateBeforeBooking.getHours() - $scope.classSettings.HoursBeforeBooking);
				$scope.testData[i]['HoursBeforeBooking'] = testDateBeforeBooking;

				var testDatedaysAheadBooking = new Date(convertedDate);
				testDatedaysAheadBooking.setDate(testDatedaysAheadBooking.getDate() - $scope.classSettings.DaysAheadBooking);

				if (today >= testDatedaysAheadBooking || $scope.classSettings.DaysAheadBooking == 0) {
					$scope.testData[i]['AheadBooking'] = true;
				} else {
					$scope.testData[i]['AheadBooking'] = false;
				}

				if ( $scope.testData[i]['PeopleAttending'] >= $scope.testData[i]['MaxClients']) {
					$scope.testData[i]['FullCapacity'] = true;
				}else{
					$scope.testData[i]['FullCapacity'] = false;
				}

				$scope.testData[i]['SlotsLeft'] = $scope.testData[i]['MaxClients'] - $scope.testData[i]['PeopleAttending'];

				// console.log($scope.testData[i]);
				if ( updateActInstr == true ){
					if ( !currentActivities.includes($scope.testData[i]['PublicEventID']) ) {
						currentActivities.push($scope.testData[i]['PublicEventID']);
					}
				}

				if ( $scope.testData[i]['InstructorIDs'] != null ) {
					var manageInstrucors = $scope.testData[i]['InstructorIDs'];

					if ( manageInstrucors.indexOf(',') > -1 ) {
						var res = manageInstrucors.split(',');

						for (var n = 0; n < res.length; n++) {
							if ( !currentInstructors.includes(res[n]) ) {
								currentInstructors.push(res[n]);
							}

							var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == res[n] });
							if ( result.length > 0 ) {
								var instructor = result[0].Name;
								if ( n > 0 ) {
									instructor = ', ' + instructor;
								}
								$scope.testData[i]['Instructors']  += instructor;
							}
						}
					}else{
						if ( !currentInstructors.includes(manageInstrucors) && manageInstrucors != '00000000-0000-0000-0000-000000000000' && manageInstrucors != '' ) {
							currentInstructors.push(manageInstrucors);
						}

						var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == manageInstrucors });
						if ( result.length > 0 ) {
							$scope.testData[i]['Instructors'] = result[0].Name;
						}
					}
				}
			}

			if ( updateActInstr == true ){
				getCurrentActivities(currentActivities);
				getCurrentInstructors(currentInstructors);
			}

			$scope.originalData = $scope.testData;
			$scope.testData = $scope.convertTo($scope.testData, 'Date', true);

			$scope.Schedule = {};
			Object.keys($scope.testData).sort().forEach(function (key) {
				$scope.Schedule[key] = $scope.testData[key];
			});

			$('body').addClass('loaded-body');

		}).error(function () {

		});
	}

	function getCurrentActivities(array){
		$scope.current_activities = [];

		for (var i = 0; i < array.length; i++) {
			var activity = array[i];
			var result = $.grep($scope.schedule_activities, function (e) { return e.Id == activity });

			if ( result.length > 0 ) {
				$scope.current_activities.push(result[0]);
			}
		}
	}

	function getCurrentInstructors(array){
		$scope.current_instructors = [];

		for (var i = 0; i < array.length; i++) {
			var instructor = array[i];
			var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == instructor });

			if ( result.length > 0 ) {
				$scope.current_instructors.push(result[0]);
			}
		}

		console.log($scope.current_instructors);
	}

	$scope.convertTo = function (arr, key, dayWise) {
		var groups = {};
		for (var i = 0; l = arr.length, i < l; i++) {
			var newDateLocal = new Date(arr[i][key]).toISOString().slice(0, 10);
			// console.log(newDateLocal);

			arr[i]['DateLocal'] = new Date(arr[i][key]).toISOString().slice(0, 10);

			groups[arr[i]['DateLocal']] = groups[arr[i]['DateLocal']] || [];
			groups[arr[i]['DateLocal']].push(arr[i]);
		}
		return groups;
	};

	$scope.updateActivity = function (activityId) {
		$('body').removeClass('loaded-body');
		$scope.activityId = activityId;
		$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid, 'dontUpdateActInstr');
		if (activityId != null) {
			var x = findElement($scope.schedule_activities, "Id", activityId);

			$scope.choosenActivity = true;
			$scope.nameActivity = x['Name'];
		} else {
			$scope.choosenActivity = false;
		}

		$('.schedule-wrapper .filter-section .filter-col-activities .dd').removeClass('show');
	}


	// Get Areas

	$scope.getAreas = function (gymid, allAreas) {
		var dataObject = {
			Namespace: namespace,
			GymId: gymid,
			AllAreas: false
		}

		if ( allAreas ) {
			dataObject = {
				Namespace: namespace,
				GymId: gymid,
				AllAreas: true
			}
		}


		$http({
			method: 'GET',
			url: '/api/public/GetAreas?AllAreas=' + allAreas + '&nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_areas = data;
		}).error(function () {

		});
	}

	$scope.updateAreaId = function (id, gymID) {
		$('body').removeClass('loaded-body');
		$('.filter-col-activities input:checked').prop('checked', false);
		$scope.choosenActivity = false;
		$scope.scheduleActivity = null;
		$scope.activityId = null;
		$('.filter-col-instructors input:checked').prop('checked', false);
		$scope.visitInstructor = 0;
		$scope.choosenInstructor = false;
		$scope.scheduleActivity = 'null';
		$scope.scheduleInstructor = '0';
		$scope.visitArea = id;
		if ( gymID ) {
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymID);
		}else{
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate);
		}
	}

	// Get Instructors
	$scope.getInstructors = function (gymid) {
		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetInstructors?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_instructors = data;
		}).error(function () {

		});
	}

	$(window).on('load', function () {
		setTimeout(function () {
			if ($scope.membershipGyms.length > 1 && $('.schedule-wrapper-main').length) {
				$('.schedule-wrapper-main').addClass('loading');
				$scope.getAreas(gymid, false);
			} else {
				$scope.getAreas(gymid, true);
				setTimeout(function () {
					$scope.getSchedule(today, todayInOneYear, gymid);
					$scope.getClientServices();
				}, 100);
				$scope.getInstructors(gymid);
			}
		}, 500);
	})

	$scope.changeScheduleZone = function () {
		var id = $scope.scheduleZone;
		var x = findElement($scope.membershipGyms, "GymID", id);
		$scope.scheduleZoneName = x.GymName;
		$scope.choosenActivity = false;
		$scope.scheduleActivity = null;
		$scope.activityId = null

		$('.filter-col-instructors input:checked').prop('checked', false);
		$scope.choosenInstructor = false;
		$scope.visitInstructor = 0;

		$scope.scheduleActivity = 'null';
		$scope.scheduleInstructor = '0';
		$scope.scheduleArea = '0';

		$scope.getAreas(id, false);
		$scope.getInstructors(id);
		$scope.getSettings(id);
		$scope.getEventsType(id);

		setTimeout(function () {
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, id);

			if (days != null) {
				$('.schedule-list').addClass('hide');
				for (var i = 0; i < days; i++) {
					$('.schedule-list .list-item').eq(i).addClass('show');
				}
			}

			$('.schedule-wrapper').removeClass('loading');
		}, 500);

	}

	$scope.getSettings = function (id) {
		var dataObject = {
		    Namespace: namespace,
		    GymID: id
		}
		$http({
			method: 'POST',
			url: '/ScheduleV2/GetSettings',
			data: dataObject
		}).success(function (data) {
			$scope.classSettings = data;

			$scope.showCapacity = data.ShowCapacityCustomersPortal;
			$scope.showInstructor = data.ShowInstructorCustomersPortal;
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.updateInstructorId = function (id) {
		$scope.visitInstructor = id;

		$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid, 'dontUpdateActInstr');

		if (id != '0') {
			var x = findElement($scope.schedule_instructors, "Id", id);

			$scope.choosenInstructor = true;
			$scope.nameInstructor = x['Name'];
		} else {
			$scope.choosenInstructor = false;
		}

		$('.schedule-wrapper .filter-section .dd').removeClass('show');
	}

	$scope.updateVisitProduct = function(id){
		if ( id != '-1') {
			var result = $.grep($scope.visitProducts, function (e) { return e.ProductID == id });
			$scope.productId = id;
			$scope.productName = result[0].ProductName;
		}else{
			$scope.productId = '-1';
			$scope.productName = 'Own equipment'
		}
	}

	// Join Event

	function paymentChange(){
		if ($scope.smodal.paymentMethod == '7') {
			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				id: $scope.PublicEventID,
			}
		    
		    $http({
		        method: 'GET',
		        url: '/api/private/GetPublicEventPrice?Namespace=' + namespace + '&GymID=' + gymid + '&id=' + $scope.PublicEventID,
		        data: dataObject
		    }).success(function (data) {
		        $scope.modalPrice = data;
		    }).error(function () {
		    });

			$('.popup-wrapper .popup .stripe-button').addClass('show');
			// Create a Stripe client.
			var stripe = Stripe($scope.classSettings.StripePublishKey);
			// Create an instance of Elements.
			var elements = stripe.elements();
			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
			  base: {
				color: '#32325d',
				lineHeight: '18px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
				  color: '#aab7c4'
				}
			  },
			  invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			  }
			};


			// Create an instance of the card Element.
			var card = elements.create('card', {style: style});

			// Add an instance of the card Element into the `card-element` <div>.
			card.mount('#card-element');

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function(event) {
				var displayError = document.getElementById('card-errors');
			  	if (event.error) {
					displayError.textContent = event.error.message;
			  	} else {
					displayError.textContent = '';
			  	}
			});

			// Handle form submission.
			var form = document.getElementById('payment-form');

			$('.stripe-button').on('click', function(e){
			    e.preventDefault();
			    if ($scope.loading == false || $scope.loading == undefined) {
			        $scope.loading = true;
			        stripe.createToken(card).then(function (result) {
			            if (result.error) {
			                // Inform the user if there was an error.
			                var errorElement = document.getElementById('card-errors');
			                errorElement.textContent = result.error.message;
			                $scope.loading = false;
			            } else {
			                // Send the token to your server.
			                $scope.token = result.token.id
			                $scope.joinEvent();
			            }
			        });
			    }
			})
		}else{
			$('.popup-wrapper .popup .stripe-button').removeClass('show');
		}
	}

	$scope.formLoaded = true;
	var joinEventResponses = new Array('joinEventResponse1', 'joinEventResponse2', 'joinEventResponse3', 'joinEventResponse4', 'joinEventResponse5', 'joinEventResponse6', 'joinEventResponse7');

	$scope.joinEvent = function () {
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			Id: $scope.modalVisit.ID,
			Email: $scope.Client.Email,
			FirstName: $scope.Client.FirstName,
			LastName: $scope.Client.LastName,
			Telephone: $scope.Client.Telephone,
			Date: $scope.modalVisit.NewDate,
			VisitName: $scope.modalVisit.VisitName,
			// PaymentMethod: $scope.paymentMethod,
			PaymentMethod: 0,
			Language: $scope.currentLang,
			ProductID: $scope.productId,
			ProductName: $scope.productName
		}

		if ( $scope.smodal.paymentMethod == '7' ) {
			dataObject.PaymentMethod = 7;
			dataObject.Token = $scope.token;
			dataObject.Price = $scope.modalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if ($scope.formLoaded = true) {
		    $scope.formLoaded = false;
		    $http({
		        method: 'POST',
		        url: '/api/private/JoinEvent',
		        data: dataObject
		    }).success(function (data) {
		        $scope.loading = false;
		        var responseI = data;
		        $scope.joinEventResponse = joinEventResponses[responseI];

		        $('#shcedule-popup .error-msg').removeClass('show');
		        $('#shcedule-popup .success-msg').addClass('show');

		        if (responseI == 0) {
		            $('#shcedule-popup .success-msg').addClass('green');
		            setTimeout(function() {
		            	if ( !$scope.formLoaded ) {
		            		$scope.closePopup();
		            	}
		            }, 3000);
		        }else{
		        	$scope.formLoaded = true;
		        }

		        if (responseI == 6) {
		            $('#shcedule-popup .success-msg').addClass('red');
		        }

		    }).error(function () {
		        $('#shcedule-popup .error-msg').addClass('show');
		        $('#shcedule-popup .form-actions .button-join').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
		    });
		}
	}

	$scope.closePopup = function () {
		$('.popup-wrapper, #shcedule-popup .success-msg').removeClass('show');
		$scope.resetForm();
		$('#shcedule-popup .success-msg').removeClass('green');
		$('#shcedule-popup .form-actions .button-join .button').addClass('disabled');
		$scope.formLoaded = true;
	}

	$scope.resetForm = function () {
		$('#shcedule-popup .popup-body').find('input').val('');
		$('#shcedule-popup .dd .dd-head').html('');
		$('.shcedule-popup .form-field .dd-field input:checked').prop('checked', false);
		$('.popup-wrapper .popup .stripe-button').removeClass('show');
		$scope.smodal = {paymentMethod: null, email: ''};
	}

	$scope.validateForm = function(){
		$('#shcedule-popup .form-actions .button').removeClass('disabled');
	}


	// Join Modal

	$scope.joinModal = function (visitId) {
		$scope.modalLoading = true;
		$scope.visitProducts = [];
		var result = $.grep($scope.originalData, function (e) { return e.ID == visitId; });

		if ( result.length > 0 ) {
			$scope.modalVisit = result[0];
			$scope.PublicEventID = result[0].PublicEventID;

			var dayOfWeek = $filter('date')($scope.modalVisit.NewDate, 'EEEE');
			var compiledeHTML = $compile("<span translate-date-object><span class='day ng-binding'>" + dayOfWeek + "</span></span>")($scope);
			$(".dayofweekn").html(compiledeHTML);


			var now = new Date();

			if (now < $scope.modalVisit.HoursBeforeBooking) {
				$('#shcedule-popup').addClass('show');
				setTimeout(function () {
					var dataObject = {
						Namespace: namespace,
						GymID: gymid,
						ID: visitId
					}

					$http({
				        method: 'GET',
				        url: '/api/public/GetEqipment?nameSpace=' + namespace + '&gymId=' + gymid + '&ID=' + visitId,
				        data: dataObject
				    }).success(function (data) {
				        $scope.visitProducts = data;
				        $scope.modalLoading = false;
				    }).error(function () {
				    });
					$('#shcedule-popup .popup').addClass('show');
					$('#shcedule-popup .form-actions .button-join').removeClass('disabled');
				}, 10);
			} else {
				$('#shcedule-not-popup').addClass('show');
				setTimeout(function () {
					$('#shcedule-not-popup .popup').addClass('show');
				}, 10);
			}

		}else{

		}

	}

	$scope.getAttendingClients = function(item){

		if(!item.AttendingClients){
			$scope.modalLoading = true;

			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				ScheduleID: item.ID,
				AreaID: item.AreaID
			}

			$http({
				method: 'GET',
				url: '/api/private/GetAttendingClients?Namespace=' + namespace + '&GymID=' + gymid + '&ScheduleID=' + item.ID + '&AreaID=' + item.AreaID,
				data: dataObject
			}).success(function (data) {
				item.attedingCleints = data;

				$scope.clientsData = item.attedingCleints;
				$('#clients-popup, #clients-popup .popup').addClass('show');
				$scope.modalLoading = false;

			}).error(function () {
				// console.log('error');
			});
		}else{
			$('#clients-popup, #clients-popup .popup').addClass('show');
			$scope.clientsData = item.AttendingClients
		}
	}


	$('.popup-wrapper .close, .popup-wrapper .popup-overlay').on('click', function (e) {
		e.preventDefault();
		$('.popup-wrapper, #shcedule-popup .popup, #shcedule-popup .error-msg, #shcedule-popup .success-msg').removeClass('show');
		$('#shcedule-popup .popup-body').removeClass('show-success show-error');
		$scope.resetForm();
	})

	// Datepickers
	$scope.currentLang = $translate.proposedLanguage() || $translate.use();

	schedule_from.datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function (dateText, inst) {
			var date = dateText;
			schedule_to.datepicker("option", "minDate", date);


			if ($scope.gym[0].Culture != 'en-US') {
				var res = date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			$scope.scheduleStartDate = date;
		}
	});

	schedule_to.datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function (dateText, inst) {
			var date = dateText;
			schedule_from.datepicker("option", "maxDate", date);

			if ($scope.gym[0].Culture != 'en-US') {
				var res = date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			var tomorrow = new Date(date);
			tomorrow.setDate(tomorrow.getDate() + 1);


			$scope.scheduleEndDate = tomorrow;
		}
	});

	if ($scope.currentLang == 'bg') {
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['bg']);
	}else if($scope.currentLang == 'es' || $scope.currentLang == 'esc'){
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['es']);
	}else{
		$('#schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['en']);
	}

	if ($scope.gym[0].Culture == 'en-US') {
		$('#schedule_to, #schedule_from').datepicker( "option", "dateFormat", "mm/dd/yy" );
	} else {
		$('#schedule_to, #schedule_from').datepicker( "option", "dateFormat", "dd/mm/yy" );
	}


	function getDate(element) {
		var date;
		try {
			date = $.datepicker.parseDate(dateFormat, element.value);
		} catch (error) {
			date = null;
		}
		return date;
	}


	$(document).on('click', '.dd .dd-head', function (e) {
		e.preventDefault();
		$(this).parent('.dd').toggleClass('show');
	});

	$(document).click(function (e) {
		if ($(e.target).closest('.dd').length === 0 && $('.dd').is('.show')) {
			$('.dd').removeClass('show');
		}
	});

	$(document).on('click', '#shcedule-popup .dd-field', function () {
		var content = $(this).find('label').html();
		$scope.paymentMethod = $(this).find('input').val();
		$('#shcedule-popup .dd-head').html(content);
		$('#shcedule-popup .dd').removeClass('show');
		paymentChange();
	})

	$('.schedule-wrapper .filter-section .date-col i').on('click', function (e) {
		$(this).parent().find('input').datepicker('show');
	})

	$(window)
	.on('load', function(){
		resizeAndDatepicker();
	})
	.on('resize', function(){
		resizeAndDatepicker();
	})

	//  Check Window Size and change datepicker options
	function resizeAndDatepicker(){
		var windowWidth = $(window).width();

		if ( windowWidth <= 768 ) {
			schedule_from.datepicker("option", "numberOfMonths", 1);
			schedule_to.datepicker("option", "numberOfMonths", 1);
		}else{
			schedule_from.datepicker("option", "numberOfMonths", 2);
			schedule_to.datepicker("option", "numberOfMonths", 2);
		}
	}

}])
.directive('translateDateObject', ['$timeout', '$translate', function ($timeout, $translate) {
	return {
		controller: function ($scope) {
			return {};
		},
		requires: 'translateDateObject',
		link: function (scope, element, attrs, thisController) {

			$timeout(function () {

				thisController.html = element[0].innerHTML;

				// CLEAN THE STRING TO GET A CLEAN NAME DAY
				var content_temp1 = thisController.html.replace('<span class="day ng-binding">', '');
				var content_temp2 = content_temp1.replace('</span>', '').toLowerCase();

				var day_name = '';

				for (var i = 0, len = content_temp2.length; i < len; i++) {
					// CHECK IF IS A CHAR
					if (content_temp2[i].match(/[a-z]/i)) {
						day_name += content_temp2[i];
					}
				}

				// CHECK THE ACTIVE LANGUAGE
				var lang = $translate.proposedLanguage() || $translate.use();

				if (lang == 'bg') {
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Понеделник</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Вторник</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Сряда</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Четвъртък</span>');
							break;
						case 'friday':
							element.html('<span class="day">Петък</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Събота</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Неделя</span>');
							break;
					}
				}

				$(document).on('click', '.lang-nav li a', function () {
					var lang = $(this).data('lang');

					if (lang == 'en') {
						switch (day_name) {
							case 'monday':
								element.html('<span class="day">Monday</span>');
								break;
							case 'tuesday':
								element.html('<span class="day">Tuesday</span>');
								break;
							case 'wednesday':
								element.html('<span class="day">Wednesday</span>');
								break;
							case 'thursday':
								element.html('<span class="day">Thursday</span>');
								break;
							case 'friday':
								element.html('<span class="day">Friday</span>');
								break;
							case 'saturday':
								element.html('<span class="day">Saturday</span>');
								break;
							case 'sunday':
								element.html('<span class="day">Sunday</span>');
								break;
						}
					} else {
						switch (day_name) {
							case 'monday':
								element.html('<span class="day">Понеделник</span>');
								break;
							case 'tuesday':
								element.html('<span class="day">Вторник</span>');
								break;
							case 'wednesday':
								element.html('<span class="day">Сряда</span>');
								break;
							case 'thursday':
								element.html('<span class="day">Четвъртък</span>');
								break;
							case 'friday':
								element.html('<span class="day">Петък</span>');
								break;
							case 'saturday':
								element.html('<span class="day">Събота</span>');
								break;
							case 'sunday':
								element.html('<span class="day">Неделя</span>');
								break;
						}
					}
				})

			});
		}
	}
}]);

scheduleApp.controller('ScheduleController', ['$scope', '$http', '$timeout', '$translate', '$compile', '$filter', function ($scope, $http, $timeout, $translate, $compile, $filter) {

	$scope.text = 'me@example.com';
	$scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	// Default variables

	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth() + 1;
	var yyyy = today.getFullYear();
	var nextYear = today.getFullYear() + 1;
	$scope.visitArea = 0;
	$scope.visitInstructor = 0;
	$scope.nameInstructor;
	$scope.choosenInstructor = false;
	$scope.nameActivity;
	$scope.choosenActivity = false;
	$scope.showFilters = showFilters;
	$scope.showCapacity = showCapacity;
	$scope.allowBooking = allowBooking;
	$scope.startMonday = startMonday;
	$scope.filterActivity = filterActivity;
	$scope.showInstructor = showInstructor;
	$scope.paymentMethods = new Array("OnSide", "Membership", "Sodexo", "MultiSport", "Voucher", "EPay", "PaySafe", "Stripe");
	$scope.listView = true;
	$scope.currentGymId = gymid;
	$scope.modalLoading = false;
	$scope.activityId = null;
	$scope.logo = logo;
	$scope.showLogo = showLogo;
	$scope.smodal = {paymentMethod: null, email: ''};
	if ( lang == null ) {
		lang = 'bg';
	}

	if( client != null ){
		$scope.client = client;
	}

	if ( gym[0].Culture ) {
		if (gym[0].Culture == 'bg-BG') {
			$scope.currency = 'лв.';
		}else if(gym[0].Culture.includes('-ES')){
			$scope.currency = 'eur';
		}else if(gym[0].Culture == "fr-CH"){
			$scope.currency = 'CHF';
		}else {
			$scope.currency = '$';
		}
	}

	$scope.gymAreaOnly = false;
	if ( gymArea ){
		$scope.gymAreaOnly = true;
	}

	$scope.lang = lang;

	if (settings) {
		$scope.classSettings = settings;
	}

	if (showFilters == false) {
		var time = new Date().getTime();
		$(document.body).bind("mousemove keypress touchstart touch", function (e) {
			time = new Date().getTime();
		});

		var timeout = 900000;

		function refresh() {
			if (new Date().getTime() - time >= timeout) {
				window.location.reload(true);
			} else {
				setTimeout(refresh, timeout);
			}
		}

		setTimeout(refresh, timeout);
	}

	if (dd < 10) {
		dd = '0' + dd
	}

	if (mm < 10) {
		mm = '0' + mm
	}

	today = mm + '/' + dd + '/' + yyyy;
	todayInOneYear = mm + '/' + dd + '/' + nextYear;

	var schedule_from = $("#schedule_from");
	var schedule_to = $("#schedule_to");
	$scope.scheduleStartDate = today;
	$scope.scheduleEndDate = todayInOneYear;

	function findElement(arr, propName, propValue) {
		for (var i = 0; i < arr.length; i++)
			if (arr[i][propName] == propValue)
				return arr[i];
		// will return undefined if not found; you could return a default instead
	}

	// Get Areas

	$scope.getAreas = function (dgymID) {
		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetAreas?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_areas = data;

			setTimeout(function() {
				if ( dgymID ) {
					$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, dgymID);
				}else{
					$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate);
				}
			}, 500);
		}).error(function () {

		});
	}

	function getMonday(d) {
		d = new Date(d);
		var day = d.getDay();

		var diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday

		$scope.scheduleStartDate = new Date(d.setDate(diff));
	}

	$scope.getEventsType = function(dgymID){
		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetPublicEvents?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_activities = data;
		}).error(function () {

		});
	}
	$scope.getEventsType();


	// Get Schedule
	$scope.getSchedule = function (from, to, dgymID, dontUpdateActInstr) {
		var updateActInstr = true;

		if ( dontUpdateActInstr != undefined ){
			updateActInstr = false;
		}

		if ($scope.startMonday == true) {
			getMonday($scope.scheduleStartDate);
		}

		if ( dgymID ) {
			gymid = dgymID;
		}

		if ( gymArea ){
			$scope.visitArea = gymArea;
		}

		if ( currentActivity ){
			$scope.activityId = currentActivity;
		}


		var dataObject = {
			GymID: gymid,
			Namespace: namespace,
			DateStart: $scope.scheduleStartDate,
			DateEnd: $scope.scheduleEndDate,
			AreaID: $scope.visitArea,
			InstructorID: $scope.visitInstructor,
			Private: true,
			PublicEventID: $scope.activityId
		}

		$http({
			method: 'POST',
			url: '/api/public/GetSchedule',
			data: dataObject
		}).success(function (data) {
			var today = new Date();
			var currentActivities = [];
			var currentInstructors = [];
			$scope.originalData = data;
			$scope.testData = [];
			$scope.calendarSchedule = [];

			angular.copy(data, $scope.testData);
			for (var i = 0; i < $scope.testData.length; ++i) {
				var DateNewDate = new Date($scope.testData[i]['Date']);
				var DateNewDateEnd = new Date($scope.testData[i]['DateEnd']);

				var convertedDate = DateNewDate.toString();
				var convertedDateEnd = DateNewDateEnd.toString();
				var x = findElement($scope.schedule_areas, "AreaID", $scope.testData[i]['AreaID']);

				$scope.testData[i]['NewDate'] = new Date(convertedDate);
				$scope.testData[i]['NewDateEnd'] = new Date(convertedDateEnd);
				if (x != undefined && x['Name'] != undefined)
				    $scope.testData[i]['AreaName'] = x['Name'];

				var testDateBeforeBooking = new Date(convertedDate);
				testDateBeforeBooking.setHours(testDateBeforeBooking.getHours() - $scope.classSettings.HoursBeforeBooking);
				$scope.testData[i]['HoursBeforeBooking'] = testDateBeforeBooking;

				var testDatedaysAheadBooking = new Date(convertedDate);
				testDatedaysAheadBooking.setDate(testDatedaysAheadBooking.getDate() - $scope.classSettings.DaysAheadBooking);

				if (today >= testDatedaysAheadBooking || $scope.classSettings.DaysAheadBooking == 0) {
					$scope.testData[i]['AheadBooking'] = true;
				} else {
					$scope.testData[i]['AheadBooking'] = false;
				}

				if ( $scope.testData[i]['PeopleAttending'] >= $scope.testData[i]['MaxClients']) {
					$scope.testData[i]['FullCapacity'] = true;
				}else{
					$scope.testData[i]['FullCapacity'] = false;
				}

				$scope.testData[i]['SlotsLeft'] = $scope.testData[i]['MaxClients'] - $scope.testData[i]['PeopleAttending'];

				var item = {
					title: $scope.testData[i]['VisitName'],
					start: $scope.testData[i]['NewDate'],
					end: $scope.testData[i]['NewDateEnd'],
					zone: $scope.testData[i]['AreaName'],
					itemId: $scope.testData[i]['ID'],
					AheadBooking: $scope.testData[i]['AheadBooking'],
					BookOnline: $scope.testData[i]['BookOnline'],
					HoursBeforeBooking: $scope.testData[i]['HoursBeforeBooking'],
					color: $scope.testData[i]['Color'],
					fullCapacity: $scope.testData[i]['FullCapacity']
				}

				$scope.calendarSchedule.push(item);

				if ( updateActInstr == true ) {
					if ( !currentActivities.includes($scope.testData[i]['PublicEventID']) ) {
						currentActivities.push($scope.testData[i]['PublicEventID']);
					}
				}

				if ( $scope.testData[i]['InstructorIDs'] != null ) {
					var manageInstrucors = $scope.testData[i]['InstructorIDs'];

					if ( manageInstrucors.indexOf(',') > -1 ) {
						var res = manageInstrucors.split(',');

						for (var n = 0; n < res.length; n++) {
							if ( !currentInstructors.includes(res[n]) ) {
								currentInstructors.push(res[n]);
							}

							var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == res[n] });
							if ( result.length > 0 ) {
								var instructor = result[0].Name;
								if ( n > 0 ) {
									instructor = ', ' + instructor;
								}
								$scope.testData[i]['Instructors']  += instructor;
							}
						}
					}else{
						if ( !currentInstructors.includes(manageInstrucors) && manageInstrucors != '00000000-0000-0000-0000-000000000000' && manageInstrucors != '' ) {
							currentInstructors.push(manageInstrucors);
						}

						var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == manageInstrucors });
						if ( result.length > 0 ) {
							$scope.testData[i]['Instructors'] = result[0].Name;
						}
					}
				}
			}

			if ( updateActInstr == true ){
				getCurrentActivities(currentActivities);
				getCurrentInstructors(currentInstructors);
			}

			$scope.originalData = $scope.testData;
			$scope.testData = $scope.convertTo($scope.testData, 'Date', true);

			$scope.Schedule = {};
			Object.keys($scope.testData).sort().forEach(function (key) {
				$scope.Schedule[key] = $scope.testData[key];
			});

			if( $('.schedule-wrapper .filter-section .switch-field a.calendar').is('.active') ){
				fullCalendar($scope.calendarSchedule);
			}


			if (days != null) {
				setTimeout(function () {
					manageDays();
					
					$('body').addClass('loaded-body');
				}, 500);
			}else{
				$('body').addClass('loaded-body');
			}
				
		}).error(function () {

		});
	}

	function getCurrentActivities(array){
		$scope.current_activities = [];

		for (var i = 0; i < array.length; i++) {
			var activity = array[i];
			var result = $.grep($scope.schedule_activities, function (e) { return e.Id == activity });

			if ( result.length > 0 ) {
				$scope.current_activities.push(result[0]);
			}
		}
	}

	function getCurrentInstructors(array){
		$scope.current_instructors = [];

		for (var i = 0; i < array.length; i++) {
			var instructor = array[i];
			var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == instructor });

			if ( result.length > 0 ) {
				$scope.current_instructors.push(result[0]);
			}
		}
	}

	function fullCalendar(calendarSchedule){
		if ( $('#calendar').children().length > 0 ) {
		    $('#calendar').fullCalendar('destroy');
		}

		$('#calendar').fullCalendar({
			events: calendarSchedule,
			listDayAltFormat: false,
            listDayFormat: 'dddd DD.MM.YYYY ',
            nowIndicator: true,
            header: {
                left: 'title',
                center: '',
                right: 'prev,next'
            },
            lang: lang,
            locale: lang,
            height: 'auto',
            slotDuration: '00:30:00',
            timeFormat: 'HH:mm',
            defaultView: 'agendaWeek',
            allDaySlot: false,
            editable: false,
            droppable: false,
            minTime: '07:00:00',
            maxTime: '23:00:00',
            eventColor: '#3799b1',
            timezone: 'Europe/Sofia',
			eventRender: function(event, element) {
				if ( event.fullCapacity == true ) {
                	element.css({
                		"opacity": 0.5,
                		"pointer-events": "none"
                	})
				}

                element.find('.fc-title').html('<span style="font-size: 1.1em; font-weight: 600;">'+event.title+'</span><span class="pull-right">'+event.zone+'</span>').css('white-space','nowrap');
			},
			eventClick: function(event, jsEvent){
				if ( $scope.allowBooking && event.AheadBooking && event.fullCapacity == false && event.BookOnline == true ){
					var convertedDate = event.start.toString();
					var convertedDateEnd = event.end.toString();
					var eventStart = new Date(convertedDate);
					var eventEnd = new Date(convertedDateEnd);
					$scope.joinModal(event.itemId);
                }
			},
			eventAfterAllRender: function(view) {
				setTimeout(function() {
					$('body').addClass('loaded-body');
				}, 1000);
			}
		});
	}

	// Get Gyms
	$scope.getGyms = function () {
		$scope.membershipGyms = [];
		var dataObject = {
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Membership/GetGyms',
			data: dataObject
		}).success(function (data) {
			if ( data.length > 0 ) {
				for (var i = 0; i < data.length; i++) {
					if ( data[i].IsOnline == true ) {
						$scope.membershipGyms.push(data[i]);
					}
				}

				$scope.gymid = $scope.membershipGyms[0].GymID;
			}else{
				$scope.gymAreaOnly = true;
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.getGyms();

	$('.schedule-wrapper .filter-section .switch-field a').on('click', function(e){
		e.preventDefault();
		var item = $(this);

		if ( !item.is('.active') ){
			item.addClass('active').siblings('.active').removeClass('active');
		}

		if ( item.is('.list') ){
			$('.schedule-list').show();
			$('#calendar').hide();
		}else{
			$('.schedule-list').hide();
			$('#calendar').show();
			fullCalendar($scope.calendarSchedule);
		}
	})

	$scope.convertTo = function (arr, key, dayWise) {
		var groups = {};

		for (var i = 0; l = arr.length, i < l; i++) {
			arr[i]['DateLocal'] = new Date(arr[i][key]).toISOString().slice(0, 10);

			groups[arr[i]['DateLocal']] = groups[arr[i]['DateLocal']] || [];
			groups[arr[i]['DateLocal']].push(arr[i]);
		}
		return groups;
	};
	$scope.getAreas();

	$scope.updateAreaId = function (id, gymID) {
		$('body').removeClass('loaded-body');
		$('.filter-col-activities input:checked').prop('checked', false);
		$('.filter-col-instructors input:checked').prop('checked', false);
		$scope.activityId = null;
		$scope.choosenActivity = false;
		$scope.scheduleActivity = 'null';
		$scope.visitInstructor = 0;
		$scope.choosenInstructor = false;
		$scope.scheduleInstructor = '0';
		$scope.visitArea = id;
		if ( gymID ) {
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymID);
		}else{
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate);
		}
	}

	$scope.getSettings = function (id) {
		var dataObject = {
		    Namespace: namespace,
		    GymID: gymid
		}
		$http({
			method: 'POST',
			url: '/ScheduleV2/GetSettings',
			data: dataObject
		}).success(function (data) {
			$scope.classSettings = data;
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.updategymId = function (gymID) {
		$('body').removeClass('loaded-body');
		$scope.visitArea = 0;
		$scope.scheduleActivity = null;
		$scope.choosenActivity = false;
		$scope.activityId = null;
		$('.filter-col-instructors input:checked').prop('checked', false);
		$scope.choosenInstructor = false;
		$scope.visitInstructor = 0;
		$scope.scheduleActivity = 'null';
		$scope.scheduleInstructor = '0';
		$scope.scheduleArea = '0';
		$scope.getAreas(gymID);
		$scope.getEventsType(gymID);
		$scope.getSettings(gymID);
		$scope.getInstructors(gymID);
		$('.schedule-wrapper .filter-section').addClass('choosedGym');
	}

	$scope.updateActivity = function (activityId) {
		$('body').removeClass('loaded-body');
		$scope.activityId = activityId;
		$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid, 'dontUpdateActInstr');

		if (activityId != null) {
			var x = findElement($scope.schedule_activities, "Id", activityId);

			$scope.choosenActivity = true;
			$scope.nameActivity = x['Name'];
		} else {
			$scope.choosenActivity = false;
		}

		$('.schedule-wrapper .filter-section .filter-col-activities .dd').removeClass('show');
	}


	// Get Instructors

	$scope.getInstructors = function (dgymID) {
		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			Namespace: namespace,
			GymID: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetInstructors?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_instructors = data;
		}).error(function () {

		});
	}

	$scope.getInstructors();

	$scope.updateInstructorId = function (id) {
		$scope.visitInstructor = id;

		$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid, 'dontUpdateActInstr');

		if (id != '0') {
			var x = findElement($scope.schedule_instructors, "Id", id);

			$scope.choosenInstructor = true;
			$scope.nameInstructor = x['Name'];
		} else {
			$scope.choosenInstructor = false;
		}

		$('.schedule-wrapper .filter-section .dd').removeClass('show');
	}

	$scope.updateVisitProduct = function(item){
		if (item.productName) {
			var result = $.grep($scope.visitProducts, function (e) { return e.ProductName == item.productName });
			result[0].ItemsLeft = ++result[0].ItemsLeft;
		}

		if ( item.productId != '-1' ) {
			var result = $.grep($scope.visitProducts, function (e) { return e.ProductID == item.productId });
			item.productName = result[0].ProductName;
			item.productItemsLeft = result[0].ItemsLeft;
			result[0].ItemsLeft = --result[0].ItemsLeft;
		}else{
			item.productName = 'Own equipment'
		}

		return item;
	}

	function getEventPrice() {
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			id: $scope.PublicEventID,
		}
	    
	    $http({
	        method: 'GET',
	        url: '/api/private/GetPublicEventPrice?Namespace=' + namespace + '&GymID=' + gymid + '&id=' + $scope.PublicEventID,
	        data: dataObject
	    }).success(function (data) {
	        // console.log(data);
	        $scope.modalPrice = data;
	        calculateEventPrice();
	    }).error(function () {
	    });
	}


	// Join Event

	function paymentChange(){
		if ($scope.smodal.paymentMethod == '7') {

			$('.shcedule-popup .form-actions .button.stripe-button').addClass('show');
			// Create a Stripe client.
			var stripe = Stripe($scope.classSettings.StripePublishKey);
			// Create an instance of Elements.
			var elements = stripe.elements();
			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
			  base: {
				color: '#32325d',
				lineHeight: '18px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
				  color: '#aab7c4'
				}
			  },
			  invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			  }
			};


			// Create an instance of the card Element.
			var card = elements.create('card', {style: style});

			// Add an instance of the card Element into the `card-element` <div>.
			card.mount('#card-element');

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function(event) {
				var displayError = document.getElementById('card-errors');
			  	if (event.error) {
					displayError.textContent = event.error.message;
			  	} else {
					displayError.textContent = '';
			  	}
			});

			// Handle form submission.
			var form = document.getElementById('payment-form');

			$('.stripe-button').on('click', function(e){
			    e.preventDefault();
			    if ($scope.loading == false || $scope.loading == undefined) {
			        $scope.loading = true;
			        stripe.createToken(card).then(function (result) {
			            if (result.error) {
			                // Inform the user if there was an error.
			                $scope.loading = false;
			                var errorElement = document.getElementById('card-errors');
			                errorElement.textContent = result.error.message;
			            } else {
			                // Send the token to your server.
			                $scope.token = result.token.id
			                $scope.joinEvent($scope.smodal.email, $scope.smodal.telephone, $scope.smodal.paymentMethod);
			            }
			        });
			    }
			})
		}else{
			$('.shcedule-popup .form-actions .button.stripe-button').removeClass('show');
		}
	}
		

	$scope.formLoaded = true;

	var joinEventResponses = new Array('joinEventResponse1', 'joinEventResponse2', 'joinEventResponse3', 'joinEventResponse4', 'joinEventResponse5', 'joinEventResponse6', 'joinEventResponse7');

	$scope.joinEvent = function (email, telephone, paymentMethod, productId) {

		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			Id: $scope.modalVisit.ID,
			Email: $scope.client ? $scope.client.Email : email,
			Date: $scope.modalVisit.NewDate,
			VisitName: $scope.modalVisit.VisitName,
			PaymentMethod: paymentMethod,
			Language: lang,
			ProductID: $scope.smodal.productId,
			ProductName: $scope.smodal.productName,
			AdditionalGuests: $scope.people
		}

		if ( $scope.classSettings.ClassBookingRequireProfile != true ) {
			dataObject.FirstName = $scope.client ? $scope.client.FirstName : $scope.scheduleFirstName;
			dataObject.LastName = $scope.client ? $scope.client.LastName : $scope.scheduleLastName;
			dataObject.Telephone = $scope.client ? $scope.client.Telephone : telephone;
		}

		if ( $scope.smodal.paymentMethod == '7' ) {
			dataObject.Token = $scope.token;
			dataObject.Price = $scope.totalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if ($scope.formLoaded == true) {
		    $scope.formLoaded = false;
		    $http({
		        method: 'POST',
		        url: '/api/private/JoinEvent',
		        data: dataObject
		    }).success(function (data) {
		        var responseI = data;
		        $scope.joinEventResponse = joinEventResponses[responseI];

		        $('#shcedule-popup .error-msg').removeClass('show');
		        $('#shcedule-popup .success-msg').addClass('show');

		        if (responseI == 0) {
		            $('#shcedule-popup .success-msg').addClass('green');

		            setTimeout(function() {
		            	if ( !$scope.formLoaded ) {
		            		$scope.closePopup();
		            	}
		            }, 3000);
		        }else{
		        	$scope.formLoaded = true;
		        }

		        if (responseI == 6) {
		            $('#shcedule-popup .success-msg').addClass('red');
		        }
		    }).error(function () {
		        $('#shcedule-popup .error-msg').addClass('show');
		        $scope.formLoaded = true;
		    });
		}
	}

	$scope.closePopup = function () {
		$('.popup-wrapper, #shcedule-popup .success-msg').removeClass('show');
		$scope.resetForm();
		$scope.formLoaded = true;
		$('#shcedule-popup .success-msg').removeClass('green');
	}

	$scope.resetForm = function () {
		$('#shcedule-popup .popup-body').find('input').val('');
		$('.shcedule-popup .form-field .dd-field input:checked').prop('checked', false);
		$('.shcedule-popup .dd .dd-head').html('');
		$('.shcedule-popup .form-actions .button.stripe-button').removeClass('show');
		$scope.people = [];
		$scope.smodal = [];
		$scope.$apply();
	}

	$scope.redirectToDashboard = function(){
		var currentHref = window.location;
		var href = currentHref.origin + '/Account/Dashboard?nameSpace=' + namespace + '&gymId=' + gymid;
		window.location.replace(href);
	}


	// Join Modal

	$scope.joinModal = function (visitId) {
		$scope.visitProducts = [];
		$scope.modalLoading = true;
		var result = $.grep($scope.originalData, function (e) { return e.ID == visitId; });

		if ( result.length > 0 ) {
			$scope.PublicEventID = result[0].PublicEventID;
			$scope.modalVisit = result[0];
			$scope.noSlotsLeft = $scope.modalVisit.SlotsLeft > 1 ? false : true;

			var dayOfWeek = $filter('date')($scope.modalVisit.NewDate, 'EEEE');
			var compiledeHTML = $compile("<span translate-date-object><span class='day ng-binding'>" + dayOfWeek + "</span></span>")($scope);
			$(".dayofweekn").html(compiledeHTML);


			var now = new Date();

			if (now < $scope.modalVisit.HoursBeforeBooking) {
				$('#shcedule-popup').addClass('show');
				setTimeout(function () {
					$('#shcedule-popup .popup').addClass('show');

					var dataObject = {
						Namespace: namespace,
						GymID: gymid,
						ID: visitId
					}

					$http({
				        method: 'GET',
				        url: '/api/public/GetEqipment?nameSpace=' + namespace + '&gymId=' + gymid + '&ID=' + visitId,
				        data: dataObject
				    }).success(function (data) {
				        $scope.visitProducts = data;
				        $scope.modalLoading = false;
				    }).error(function () {

				    });
				}, 10);

				getEventPrice();
			} else {
				$('#shcedule-not-popup').addClass('show');
				setTimeout(function () {
					$('#shcedule-not-popup .popup').addClass('show');
				}, 10);
			}

		}else{

		}
	}

	$scope.getAttendingClients = function(item){

		if(!item.AttendingClients){
			$scope.modalLoading = true;

			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				ScheduleID: item.ID,
				AreaID: item.AreaID
			}

			$http({
				method: 'GET',
				url: '/api/private/GetAttendingClients?Namespace=' + namespace + '&GymID=' + gymid + '&ScheduleID=' + item.ID + '&AreaID=' + item.AreaID,
				data: dataObject
			}).success(function (data) {
				item.attedingCleints = data;

				$scope.clientsData = item.attedingCleints;
				$('#clients-popup, #clients-popup .popup').addClass('show');
				$scope.modalLoading = false;

			}).error(function () {
				// console.log('error');
			});
		}else{
			$('#clients-popup, #clients-popup .popup').addClass('show');
			$scope.clientsData = item.AttendingClients
		}
	}

	// $scope.dashLogin = true;
	$scope.loginModal = function () {
	    $scope.modalLoading = true;

	    $('#login-popup').addClass('show');
	    $('#login-popup .popup').addClass('show');
	    $timeout(function() {
	        $scope.modalLoading = false;            
	    }, 100);
	}

	function calculateEventPrice(){
		if ( $scope.people.length > 0 ) {
			$scope.additionPrice = 0;
			for (var i = 0; i < $scope.people.length; i++) {
				$scope.additionPrice += $scope.modalPrice;
			}

			$scope.totalPrice = $scope.additionPrice + $scope.modalPrice;
		}else{
			$scope.totalPrice = $scope.modalPrice;
		}

		$scope.noSlotsLeft = $scope.modalVisit.SlotsLeft > $scope.people.length + 1 ? false : true;
	}

	$scope.people = [];
	$scope.noSlotsLeft = false;

	$scope.addPerson = function(){
		let person = {};
		$scope.people.push(person);
		calculateEventPrice();
	}

	$scope.deletePerson = function(index){
		let item = $scope.people[index];

		if (item.productId > -1) {
			let result = $.grep($scope.visitProducts, function (e) { return e.ProductID == item.productId });
			result[0].ItemsLeft = ++result[0].ItemsLeft;
		}
		$scope.people.splice(index,1);
		calculateEventPrice();
	}

	$('.popup-wrapper .close, .popup-wrapper .popup-overlay').on('click', function (e) {
		e.preventDefault();
		$('.popup-wrapper, #shcedule-popup .popup, #shcedule-popup .error-msg, #shcedule-popup .success-msg').removeClass('show');
		$scope.resetForm();
	})

	// Datepickers

	schedule_from.datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function (dateText, inst) {
			var date = $(this).val();
			schedule_to.datepicker("option", "minDate", date);

			if (gym[0].Culture != 'en-US') {
				var res = date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			$scope.scheduleStartDate = date;
		}
	});

	schedule_to.datepicker({
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function (dateText, inst) {
			var date = $(this).val();
			schedule_from.datepicker("option", "maxDate", date);

			if (gym[0].Culture != 'en-US') {
				var res = date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			var tomorrow = new Date(date);
			tomorrow.setDate(tomorrow.getDate() + 1);

			$scope.scheduleEndDate = tomorrow;
		}
	});

	if (gym[0].Culture == 'en-US') {
		$('#schedule_to, #schedule_from').datepicker( "option", "dateFormat", "mm/dd/yy" );
	} else {
		$('#schedule_to, #schedule_from').datepicker( "option", "dateFormat", "dd/mm/yy" );
	}


	function getDate(element) {
		var date;
		try {
			date = $.datepicker.parseDate(dateFormat, element.value);
		} catch (error) {
			date = null;
		}
		return date;
	}


	$(document).on('click', '.dd .dd-head', function (e) {
		e.preventDefault();
		$(this).parent('.dd').toggleClass('show');
	});

	$(document).click(function (e) {
		if ($(e.target).closest('.dd').length === 0 && $('.dd').is('.show')) {
			$('.dd').removeClass('show');
		}
	});

	$(document).on('click', '#shcedule-popup .dd-field', function () {
		var content = $(this).find('label').html();
		var dd = $(this).parents('.dd');
		dd.find('.dd-head').html(content);
		dd.removeClass('show');
		paymentChange();
	})

	$('.schedule-wrapper .filter-section .date-col i').on('click', function (e) {
		$(this).parent().find('input').datepicker('show');
	})

	function manageDays(){
		$('.schedule-list .col').removeClass('show');
		$('.schedule-list').addClass('hide');
		for (var i = 0; i < days; i++) {
			$('.schedule-list .col').eq(i).addClass('show');
		}
	}

	function scroll(){

		var windowHeight = $(window).height();
		var contentHeight = $('.schedule-wrapper').height();

		console.log(windowHeight);
		console.log(contentHeight);

		if ( contentHeight > windowHeight ) {
			var timeScrollDown = contentHeight;
			var timeScrollUp = contentHeight;

			if ( (contentHeight - windowHeight) > 2000 ) {
				timeScrollDown = parseInt(timeScrollDown*25);
				timeScrollUp = parseInt(timeScrollUp*20);
			}else if ( (contentHeight - windowHeight) > 500 ){
				timeScrollDown = parseInt(timeScrollDown*25);
				timeScrollUp = parseInt(timeScrollUp*10);
			}else if( (contentHeight - windowHeight) > 250 ){
				timeScrollDown = parseInt(timeScrollDown*22);
				timeScrollUp = parseInt(timeScrollUp*7);
			}else if( (contentHeight - windowHeight) > 100 ){
				timeScrollDown = parseInt(timeScrollDown*21);
				timeScrollUp = parseInt(timeScrollUp*5);
			}else{
				timeScrollDown = parseInt(timeScrollDown*20);
				timeScrollUp = parseInt(timeScrollUp*3);
			}
			
			if ( $(window).scrollTop() == 0 ){
				$('html, body').clearQueue();
  				$('html, body').stop();
  				setTimeout(function() {
					$("html, body").animate({ scrollTop: $(document).height() }, timeScrollDown, 'linear');
  				}, 2000);
			}else if ( $(window).scrollTop() + $(window).height() == $(document).height() ){
				$('html, body').clearQueue();
  				$('html, body').stop();
  				setTimeout(function() {
					$('html, body').animate({scrollTop:0}, timeScrollUp, 'linear');
  				}, 2000);
			}
		}
	}
	
	$(window)
	.on('load', function () {
		setTimeout(function () {

			if (calendarView) {
				$('.schedule-wrapper .filter-section .switch-field a.calendar').trigger('click');
			}else{
				$('#calendar').hide();
				$('body').addClass('loaded-body');
			}

			if (pageScroll) {
				scroll();
			}
			
		}, 1000);

		resizeAndDatepicker();
	})
	.on('resize', function(){
		resizeAndDatepicker();
	})
	.on('scroll', function(){
		if (pageScroll) {
			scroll();
		}
	})

	$scope.dateFeaturedFormat = 'dd/MM/yyyy';

	if (gym) {
		if (gym[0].PortalColor != null && gym[0].PortalColor != 'default') {
			$('.schedule-wrapper').addClass('theme-' + gym[0].PortalColor);
		}

		if ( gym[0].Culture == 'en-US' ) {
			$scope.dateFeaturedFormat = 'MM/dd/yyyy';
		}
	}

	//  Check Window Size and change datepicker options
	function resizeAndDatepicker(){
		var windowWidth = $(window).width();

		if ( windowWidth <= 768 ) {
			schedule_from.datepicker("option", "numberOfMonths", 1);
			schedule_to.datepicker("option", "numberOfMonths", 1);
		}else{
			schedule_from.datepicker("option", "numberOfMonths", 2);
			schedule_to.datepicker("option", "numberOfMonths", 2);
		}
	}

}])
.controller('GetScheduleController', ['$scope', '$http', '$timeout', '$translate', '$compile', '$filter', function ($scope, $http, $timeout, $translate, $compile, $filter) {
	$scope.noSchedule = false;

	if ( schedule != null ) {
		$scope.schedule = schedule;
		$scope.gym = gym[0];
		$scope.visitProducts = $scope.schedule.Products;

		if ( lang == null ){
			lang = 'en';
		}

		var DateNewDate = new Date($scope.schedule['Date']);
		var DateNewDateEnd = new Date($scope.schedule['DateEnd']);

		var convertedDate = DateNewDate.toString();
		var convertedDateEnd = DateNewDateEnd.toString();

		$scope.schedule['NewDate'] = new Date(convertedDate);
		$scope.schedule['NewDateEnd'] = new Date(convertedDateEnd);


		var dayOfWeek = $filter('date')($scope.schedule.NewDate, 'EEEE');
		var compiledeHTML = $compile("<span translate-date-object><span class='day ng-binding'>" + dayOfWeek + "</span></span>")($scope);
		$(".dayofweekn").html(compiledeHTML);

	    $scope.getSettings = function (id) {
			var dataObject = {
			    Namespace: namespace,
			    GymID: gymid
			}
			$http({
				method: 'POST',
				url: '/ScheduleV2/GetSettings',
				data: dataObject
			}).success(function (data) {
				console.log(data);
				$scope.classSettings = data;
			}).error(function () {
				// console.log('error');
			});
		}

		$scope.getSettings();


		$scope.updateVisitProduct = function(id){
			if ( id != '-1' ) {
				var result = $.grep($scope.visitProducts, function (e) { return e.ProductID == id });
				$scope.productId = id;
				$scope.productName = result[0].ProductName;
			}else{
				$scope.productId = '-1';
				$scope.productName = 'Own equipment'
			}
		}


		// Join Event

		$scope.formLoaded = true;

		var joinEventResponses = new Array('joinEventResponse1', 'joinEventResponse2', 'joinEventResponse3', 'joinEventResponse4', 'joinEventResponse5', 'joinEventResponse6', 'joinEventResponse7');

		$scope.joinEvent = function (email, telephone, paymentMethod, productId) {

			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				Id: $scope.schedule.ID,
				Email: email,
				FirstName: $scope.scheduleFirstName,
				LastName: $scope.scheduleLastName,
				Telephone: telephone,
				Date: $scope.schedule.NewDate,
				VisitName: $scope.schedule.VisitName,
				PaymentMethod: paymentMethod,
				Language: lang,
				ProductID: $scope.productId,
				ProductName: $scope.productName
			}

			if ( $scope.classSettings.ClassBookingRequireProfile == true ) {
				dataObject = {
					Namespace: namespace,
					GymID: gymid,
					Id: $scope.schedule.ID,
					Email: email,
					Date: $scope.schedule.NewDate,
					VisitName: $scope.schedule.VisitName,
					PaymentMethod: paymentMethod,
					Language: lang,
					ProductID: $scope.productId,
					ProductName: $scope.productName
				}
			}

			if ($scope.formLoaded == true) {
			    $scope.formLoaded = false;
			    $http({
			        method: 'POST',
			        url: '/api/private/JoinEvent',
			        data: dataObject
			    }).success(function (data) {
			        var responseI = data;
			        $scope.joinEventResponse = joinEventResponses[responseI];

			        $('.event-single-box .error-msg').removeClass('show');
			        $('.event-single-box .success-msg').addClass('show');

			        if (responseI == 0) {
			            $('.event-single-box .success-msg').addClass('green');
			        }

			        if (responseI == 6) {
			            $('.event-single-box .success-msg').addClass('red');
			        }
			        $scope.formLoaded = true;
			    }).error(function () {
			        $('.event-single-box .error-msg').addClass('show');
			        $scope.formLoaded = true;
			    });
			}
		}

		$(document).on('click', '.dd .dd-head', function (e) {
			$(this).parent('.dd').toggleClass('show');
		});

		$(document).click(function (e) {
			if ($(e.target).closest('.dd').length === 0 && $('.dd').is('.show')) {
				$('.dd').removeClass('show');
			}
		});

		$(document).on('click', '.event-single-box .dd-field', function () {
			var content = $(this).find('label').html();
			var dd = $(this).parents('.dd');
			dd.find('.dd-head').html(content);
			dd.removeClass('show');
		})

		if (gym) {
			if (gym[0].PortalColor != null && gym[0].PortalColor != 'default') {
				$('.schedule-wrapper').addClass('theme-' + gym[0].PortalColor);
			}
		}
	}else{
		$scope.noSchedule = true;
	}


}])
.controller('ScheduleEventInfoController', ['$scope', '$http', '$timeout', '$translate', function ($scope, $http, $timeout, $translate) {

	$scope.schedule = schedule;
	$scope.client = client;
	$scope.attending = attending;

	var scheduleDate = new Date(schedule.Date);
	var dateBeforeCancel = new Date(schedule.Date);
	dateBeforeCancel.setHours(dateBeforeCancel.getHours() - settings.HoursBeforeCanceling);
	var today = new Date();

	if (scheduleDate > today) {
		$scope.canCancel = true;
	}

	function findElement(arr, propName, propValue) {
		for (var i = 0; i < arr.length; i++)
			if (arr[i][propName] == propValue)
				return arr[i];
		// will return undefined if not found; you could return a default instead
	}

	// Get Areas
	$scope.getAreas = function () {
		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetAreas?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			var x = findElement(data, "AreaID", $scope.schedule.AreaID);
			$scope.areaName = x['Name'];

		}).error(function () {

		});
	}

	$scope.getAreas();

	$scope.leaveEvent = function () {
		var now = new Date();

		if (now < dateBeforeCancel) {
			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				Id: $scope.schedule.ID,
				ClientID: $scope.client.ClientID
			}

			$http({
				method: 'POST',
				url: '/api/private/leaveEvent',
				data: dataObject
			}).success(function (data) {
				if (data == true) {
					$('.event-box .actions').addClass('show-success');
				}
			}).error(function () {

			});
		} else {
			$('.event-box .actions').addClass('show-error');
		}
	}

}])
.directive('translateDateObjectSchedule', function ($timeout) {
	return {
		controller: function ($scope) {
			return {};
		},
		requires: 'translateDateObjectSchedule',
		link: function (scope, element, attrs, thisController) {

			$timeout(function () {

				thisController.html = element[0].innerHTML;

				// CLEAN THE STRING TO GET A CLEAN NAME DAY
				var content_temp1 = thisController.html.replace('<span class="day ng-binding">', '');
				var content_temp2 = content_temp1.replace('</span>', '').toLowerCase();

				var day_name = '';

				for (var i = 0, len = content_temp2.length; i < len; i++) {
					// CHECK IF IS A CHAR
					if (content_temp2[i].match(/[a-z]/i)) {
						day_name += content_temp2[i];
					}
				}

				// CHECK THE ACTIVE LANGUAGE
				if (lang == 'bg') {
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Понеделник</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Вторник</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Сряда</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Четвъртък</span>');
							break;
						case 'friday':
							element.html('<span class="day">Петък</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Събота</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Неделя</span>');
							break;
					}
				}else if (lang == 'es' || lang == 'esc'){
					// ASSIGN A DIFFERENT TRANSLATION FOR EACH DAY
					switch (day_name) {
						case 'monday':
							element.html('<span class="day">Lunes</span>');
							break;
						case 'tuesday':
							element.html('<span class="day">Martes</span>');
							break;
						case 'wednesday':
							element.html('<span class="day">Miércoles</span>');
							break;
						case 'thursday':
							element.html('<span class="day">Jueves</span>');
							break;
						case 'friday':
							element.html('<span class="day">Viernes</span>');
							break;
						case 'saturday':
							element.html('<span class="day">Sábado</span>');
							break;
						case 'sunday':
							element.html('<span class="day">Domingo</span>');
							break;
					}
				}
			});
		}
	}
})
.directive('numbersOnly', function () {
	return {
		require: 'ngModel',
		link: function (scope, element, attr, ngModelCtrl) {
			function fromUser(text) {
				if (text) {
					var transformedInput = text.replace(/[^0-9]/g, '');

					if (transformedInput !== text) {
						ngModelCtrl.$setViewValue(transformedInput);
						ngModelCtrl.$render();
					}
					return transformedInput;
				}
				return undefined;
			}
			ngModelCtrl.$parsers.push(fromUser);
		}
	};
});